import React, { useEffect, useState } from "react";
import styles from ".//NewSinglePackage.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  calculateLOS,
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../../utils/utils";
import moment from "moment";
import OgMetaTitles from "../../PageMetaData/OgMetaTitles";
import PageMetaData from "../../PageMetaData/PageMetaData";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import EditNewUiSinglePackageSearchFormHolidays from "../NewUiSearchForm/NewUiSearchFormHolidays/EditNewUiSinglePackageSearchFormHolidays";
import Skeleton from "react-loading-skeleton";
import {
  CrossWithBorder,
  SvgAccordion,
  SvgLocation,
} from "../../../utils/svgIcons";
import PackageDetails from "../../ButtonToDownload/PackageDetails";
import NewShare from "../NewShareMailPrint/NewShare";
import NewPrint from "../NewShareMailPrint/NewPrint/NewPrint";
import { Fancybox } from "@fancyapps/ui";
import NewUiSinglePackageAccommodation from "../NewUIPackages/SinglePackagePage/NewUiSinglePackageAccommodation";
import PackageQueryForm from "../../NewSendEnquiryPopup/PackageQueryForm";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import imgNotFound from "../../../assets/images/single-image.png";
import SinglePackageSearchForm from "./SinglePackageSearchForm";
import AgentSideBar from "../../../Pages/Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../../Pages/Agent/AgentHeader/AgentHeader";
import NewDownloadPdfButton from "../../ButtonToDownload/NewDownloadPdfButton";
import NewUIPackagePrint from "../NewShareMailPrint/NewPrint/NewUIPackagePrint";

const NewSinglePackageSearchPage = () => {
  // All Hooks
  const userType = localStorage.getItem("userType");
  const userToken = localStorage.getItem("token");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));
  const navigate = useNavigate();
  const { packageHandle } = useParams();
  // All Hooks End

  // All States
  const [loader, setLoader] = useState(false);
  const [singlePackage, setSinglePackage] = useState({});
  const [allDestinations, setAllDestinations] = useState([]);
  const [filter, setFilter] = useState("detailed_itinerary");
  const [detailedFilter, setDetailedFilter] = useState("overview");
  const [openIndex, setOpenIndex] = useState(0);
  const [openOuterAccordion, setOpenOuterAccordion] = useState([
    "detailed_itinerary",
  ]);

  // Accommodation States
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [ratesOfPackages, setRatesOfPackages] = useState(null);
  const [allPackageHotels, setAllPackageHotels] = useState([]);
  const [packageRates, setPackageRates] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [commission, setCommission] = useState({});
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [markupData, setMarkupData] = useState([]);
  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [activePayment, setActivePayment] = useState("priceSummary");
  const [selectedHotelId, setSelectedHotelId] = useState(null);
  const [promotions, setPromotions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [date, setDate] = useState({
    setDay: "",
    setMonth: "",
    setYear: "",
  });
  const [guest, setGuest] = useState(2);
  const [data, setData] = useState(null);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [showRatePopup, setshowRatePopup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);
  const [packageId, setPackageId] = useState(null);
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);

  const calculateNights = (data) => {
    let destinations = [];
    let currentDestination = null;
    let nights = 0;

    if (data) {
      for (let i = 0; i < data.length; i++) {
        const { startDestination, endDestination } = data[i];

        // Ignore the first transit destination (like "Chandigarh")
        if (i === 0) continue;

        if (currentDestination === startDestination) {
          nights++; // Continue counting nights
        } else {
          if (currentDestination) {
            destinations.push({
              destination: currentDestination,
              night: nights,
            });
          }
          currentDestination = startDestination;
          nights = 1; // Start new night count
        }
      }
    }

    // Push the last counted destination
    if (currentDestination) {
      destinations.push({ destination: currentDestination, night: nights });
    }

    return destinations;
  };

  useEffect(() => {
    if (singlePackage) {
      const destinationData = calculateNights(singlePackage?.packageItinerary);
      setAllDestinations(destinationData);
    }
  }, [singlePackage]);

  // Filter Scroll Section
  // const handleScrollToSection = (sectionValue) => {
  //   setFilter(sectionValue);
  //   document
  //     .getElementById(sectionValue)
  //     ?.scrollIntoView({ behavior: "smooth" });
  // };

  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    setOpenOuterAccordion([sectionValue]);

    const section = document.getElementById(sectionValue);
    if (section) {
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      const sectionHeight = section.offsetHeight;
      const windowHeight = window.innerHeight;

      const scrollTo = sectionPosition - windowHeight / 2 + sectionHeight / 2;

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      });
    }

    setShowAllTabs(false);
    setOpenOuterAccordion([sectionValue]);
  };

  useEffect(() => {
    const sections = document.querySelectorAll(".scroll-section");

    const observer = new IntersectionObserver(
      (entries) => {
        let visibleSection = filter;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleSection = entry.target.id;
          }
        });
        setFilter(visibleSection);
      },
      { threshold: 0.3 } // Change threshold to 30% visibility
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  // Filter Scroll Section End

  const handleDetailedFilter = (value) => {
    setDetailedFilter(value);
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // All Functions End

  // Custom Arrays
  const detailedItinerary = [
    { label: "Overview", value: "overview" },
    // {
    //   label: singlePackage.totalDays + " " + "Days Itinerary",
    //   value: "itinerary",
    // },
    { label: "Accommodation", value: "accommodation" },
    // { label: "Gallery", value: "gallery" },
  ];

  const mainFilters = [
    { label: "Detailed Itinerary", value: "detailed_itinerary" },
    { label: "Stays", value: "stays" },
    { label: "Inclusions & Exclusions", value: "inclusion_exclusion" },
    { label: "Things to Know", value: "points_to_remember" },
    { label: "Terms & Conditions", value: "terms_and_conditions" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
  ];
  const [activeFilter, setActiveFilter] = useState("detailed_itinerary");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };

  // Accommodation Code
  // markup fetch api
  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          // console.log("findObject", findObject);

          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const handleSelectedAddOns = (addon) => {
    setSelectedAddOns((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === addon.id
      );
      if (isSelected) {
        return prevSelected.filter((selected) => selected.id !== addon.id);
      } else {
        return [...prevSelected, addon];
      }
    });
  };

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  const togglePaymentDetails = () => {
    setPaymentDetails(!paymentDetails);
  };

  const handleButtonClick = () => {
    setActivePayment((prev) =>
      prev === "priceSummary" ? "priceDetails" : "priceSummary"
    );
  };

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const storedData = JSON.parse(localStorage.getItem("selected"));

  const agentDetails = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    if (storedData) {
      setData(selectedHotelId);
    }
  }, [localStorage]);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const [activeTab, setActiveTab] = useState("package-information");

  const handleshowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(!showRatePopup);
  };

  const postQueryData = () => {};

  const location = useLocation();

  const commissionAmount = commission?.commissionAmount;
  const commissionType = commission?.commissionType;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }
    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      departureDay: params.get("checkinDay"),
      departureMonth: params.get("checkinMonth"),
      departureYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      date: params.get("date"),
      day: params.get("day"),
      month: params.get("month"),
      year: params.get("year"),
      packageId: params.get("packageId"),
      packageHandle: packageHandle,
    };

    setDate({
      setDay: data.day,
      setMonth: data.month,
      setYear: data.year,
    });

    setPackageId(data.packageId);

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    setLoader(true);

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/single/${packageHandle}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setSinglePackage(data?.data);
        {
          data?.data?.additionalDetails?.featured_category
            ? setSelectedCategory(
                data?.data?.additionalDetails?.featured_category
              )
            : setSelectedCategory(data?.data?.hotelCategory[0]);
        }
        {
          data?.data?.additionalDetails?.featured_meal_plan &&
            setSelectedMealPlan(
              data?.data?.additionalDetails?.featured_meal_plan
            );
        }

        const allAccommodations = data?.data?.packageItinerary.flatMap(
          (item) => item.accommodation
        );

        if (allAccommodations) {
          const uniqueAccommodations = Array.from(
            new Map(
              allAccommodations?.map((hotel) => [hotel?.accommodationId, hotel])
            ).values()
          );
          setAllPackageHotels(uniqueAccommodations);
        }

        setPackageRates(data?.data?.packageRates);
        scrollToTop();
        setLoader(false);
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );

    let checkInDate = currentDateSingle;

    if (data.year && data.month && data.day) {
      checkInDate = `${data.year}-${String(data.month).padStart(
        2,
        "0"
      )}-${String(data.day).padStart(2, "0")}`;
    }

    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
    });

    setGuest(data.guest);
    setChildren(data.children);
    setRooms(data.room);
    setChildAge(childAges);

    if (data.day && data.month && data.year) {
      setStartDate(checkInDate);
    } else {
      setStartDate(currentDateSingle);
    }
    // setStartDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData(data);

    fetchPromotions({
      checkInDateFromBooking: checkInDate,
      packageIdFromBooking: Number(data?.packageId),
    });
  }, [location.search]);

  const totalAddonsCostWithoutCommission = selectedAddOns?.reduce(
    (total, addon) => {
      if (addon.priceWithMarkup) {
        if (addon.perPerson && guest) {
          return total + Number(addon.priceWithMarkup) * Number(guest);
        } else {
          return total + Number(addon.priceWithMarkup);
        }
      }
    },
    0
  );

  const totalAddonsCost = selectedAddOns?.reduce((total, addon) => {
    if (addon.perPerson && guest) {
      return total + Number(addon.finalAddonPrice) * Number(guest);
    } else {
      return total + Number(addon.finalAddonPrice);
    }
  }, 0);

  const [priceLoader, setPriceLoader] = useState(false);
  const getRatesFromApi = async (
    packageId,
    pax,
    selectedCategory,
    selectedMealPlan
  ) => {
    // console.log(
    //   packageId,
    //   pax,
    //   selectedCategory,
    //   selectedMealPlan,
    //   "getRatesFromApi"
    // );
    setPriceLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    // children older than 6
    // const childrenAbove6 = childAge?.filter((age) => age > 6).length || 0;
    // const no_pax = Number(guest) + Number(childrenAbove6);

    const formdata = new FormData();
    formdata.append("package_id", packageId);
    // formdata.append("no_pax", no_pax);
    formdata.append("no_pax", pax == 1 ? 2 : pax);

    formdata.append("hotelCategory", selectedCategory);
    formdata.append("mealPlan", selectedMealPlan ? selectedMealPlan : "na");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const MIN_LOADING_TIME = 800;

    try {
      const startTime = Date.now();
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/rate`,
        requestOptions
      );
      const result = await response.json();
      setRatesOfPackages(result?.data);
      const timeElapsed = Date.now() - startTime;
      const remainingTime = MIN_LOADING_TIME - timeElapsed;

      if (remainingTime > 0) {
        setTimeout(() => setPriceLoader(false), remainingTime);
      } else {
        setPriceLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // console.log(
  //   singlePackage?.packageId,
  //   bookingData?.guest,
  //   selectedCategory,
  //   selectedMealPlan,
  //   "asdas"
  // );

  useEffect(() => {
    if (
      singlePackage?.packageId &&
      bookingData?.guest &&
      selectedCategory &&
      selectedMealPlan
    ) {
      getRatesFromApi(
        singlePackage?.packageId,
        bookingData?.guest,
        selectedCategory,
        selectedMealPlan
      );
    }
  }, [singlePackage, bookingData?.guest, selectedCategory, selectedMealPlan]);

  const childWithAgeLessThanSix = bookingData?.childAge?.filter(
    (age) => age < 6
  )?.length;

  // reusable fn
  function calculateFinalPrice(basePrice, markupData, commissionData) {
    let finalPrice = 0;
    let priceAfterMarkup = 0;

    if (!basePrice || typeof basePrice !== "number" || basePrice <= 0) {
      return;
    }

    finalPrice = basePrice;

    // Apply Markup
    if (markupData?.markupType && markupData?.amount) {
      if (markupData.markupType === "percentage") {
        finalPrice += (basePrice * markupData.amount) / 100;
      } else if (markupData.markupType === "fixed") {
        finalPrice += Number(markupData.amount);
      }
    }
    priceAfterMarkup = finalPrice;

    // Apply Commission
    // if (commissionData?.commissionType && commissionData?.commissionAmount) {
    //   if (commissionData.commissionType === "percentage") {
    //     finalPrice -= (finalPrice * commissionData.commissionAmount) / 100;
    //   } else if (commissionData.commissionType === "fixed") {
    //     finalPrice -= Number(commissionData.commissionAmount);
    //   }
    // }

    return { finalPrice, priceAfterMarkup };
  }

  function calculateTotalAmount(
    basePrice = 0,
    selectedAutomaticDiscount,
    selectedDiscount,
    // discount = 0,
    // discountType = "fixed",
    guest = 2,
    ratesOfPackages,
    childAgeArray,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType
  ) {
    const childWithAgeGreaterThanSix = childAgeArray.filter(
      (age) => age > 6
    )?.length;
    const childWithAgeLessThanSix = childAgeArray.filter(
      (age) => age < 6
    )?.length;
    const perPaxCount =
      Number(bookingData.guest) +
      childAgeArray?.length +
      ratesOfPackages?.ExtraAdultCount;

    guest = Number(guest);

    // discount = Number(discount);

    let startingPrice = basePrice;
    let markupAmount;
    let commissionAmt;

    if (markupData?.markupType) {
      if (markupData?.markupType === "percentage") {
        markupAmount = (basePrice * markupData?.amount) / 100;
      } else {
        markupAmount = Number(markupData?.amount);
      }
    }

    let onlyAdultCost = 0;

    if (markupAmount && basePrice) {
      basePrice = Number(basePrice) + markupAmount;
    }

    const preCommissionPrice = basePrice;

    const postCommissionPrice = basePrice;

    const agentSavings = preCommissionPrice - postCommissionPrice;

    onlyAdultCost = basePrice * guest;
    basePrice = basePrice * guest;

    let adjustedPackagePrice = startingPrice;

    let adultCosts = 0;
    let extraAdultSavings = 0;

    if (ratesOfPackages?.ExtraAdultCount) {
      adultCosts =
        Number(ratesOfPackages?.ExtraAdultCount) *
        Number(ratesOfPackages?.ExtraAdult);

      // const preExtraAdultPrice = adultCosts;
      let extraAdultMarkuoAmount;
      let extraAdultCommissionAmount;

      if (markupData?.markupType) {
        if (markupData?.markupType === "percentage") {
          extraAdultMarkuoAmount = (adultCosts * markupData?.amount) / 100;
        } else {
          extraAdultMarkuoAmount = Number(markupData?.amount);
        }
      }

      if (adultCosts && extraAdultMarkuoAmount) {
        adultCosts += extraAdultMarkuoAmount;
      }

      const preExtraAdultPostMarkup = adultCosts;

      // if (commissionAmount && commissionType) {
      //   if (commissionType === "percentage") {
      //     extraAdultCommissionAmount =
      //       (Number(adultCosts) * Number(commissionAmount)) / 100;
      //   } else if (commissionType === "fixed") {
      //     extraAdultCommissionAmount = Number(commissionAmount);
      //   }
      // }

      // if (adultCosts && extraAdultCommissionAmount) {
      //   adultCosts -= extraAdultCommissionAmount
      // }

      basePrice = basePrice + adultCosts;
      const postExtraAdultPrice = adultCosts;

      extraAdultSavings = preExtraAdultPostMarkup - postExtraAdultPrice;
    }

    let childCosts = 0;
    let childCostWithBed = 0;
    let childCostWithOutBed = 0;
    let childSavingsWithBed = 0;
    let childSavingsWithoutBed = 0;

    // if (childAgeArray?.length > 0) {
    //   childAgeArray.forEach((age) => {
    //     if (Number(age) >= 6) {
    //       // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithBedCost,
    //         markupData,
    //         commission
    //       );

    //       childCostWithBed += Number(result?.finalPrice);
    //       // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //     } else {
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithOutBedCost,
    //         markupData,
    //         commission
    //       );

    //       if (volvoAddonPrice !== undefined) {
    //         const volvoCost =
    //           +volvoAddonPrice / Number(childWithAgeLessThanSix);
    //         childCostWithOutBed +=
    //           Number(result?.finalPrice) + result?.volvoCost;
    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       } else {
    //         childCostWithOutBed += Number(result?.finalPrice);
    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       }
    //     }
    //   });
    // }

    if (childAgeArray?.length > 0) {
      childAgeArray.forEach((age) => {
        if (Number(age) >= 6) {
          // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithBedCost,
            markupData,
            commission
          );

          childCostWithBed += Number(result?.finalPrice);
          // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
        } else if (Number(age) < 6) {
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithOutBedCost,
            markupData,
            commission
          );

          if (volvoAddonPrice !== undefined) {
            const volvoCost =
              +volvoAddonPrice / Number(childWithAgeLessThanSix);
            // childCostWithOutBed += Number(result?.finalPrice) + result?.volvoCost;
            // const volvoCost = +volvoAddonPrice;
            childCostWithOutBed += volvoCost;

            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          } else {
            childCostWithOutBed += 0;
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          }
        }
      });
    }

    let totalAgentSavings =
      agentSavings * guest +
      extraAdultSavings +
      childSavingsWithBed +
      childSavingsWithoutBed;

    // if (commissionAmount && commissionType && totalAddonsCostWithoutCommission && totalAddonsCost) {
    //   totalAgentSavings += (totalAddonsCostWithoutCommission - totalAddonsCost)
    // }

    let totalChildCostPrice = childCostWithBed + childCostWithOutBed;

    if (totalChildCostPrice) {
      basePrice += totalChildCostPrice;
    }

    let discountAmount;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedAutomaticDiscount &&
        selectedAutomaticDiscount?.length > 0 &&
        selectedAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedDiscount &&
        selectedDiscount?.length > 0 &&
        selectedDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };
    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(basePrice);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(basePrice) -
        Number(
          totalBookingAutomaticDiscountAmount
            ? totalBookingAutomaticDiscountAmount
            : 0
        )
    );

    discountAmount =
      Number(totalBookingAutomaticDiscountAmount) +
      Number(totalBookingDiscountAmount);
    // if (discountType === "percentage") {
    //   discountAmount = (basePrice * discount) / 100;
    // } else {
    //   discountAmount = discount;
    // }

    const priceAfterDiscount = basePrice - discountAmount;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (priceAfterDiscount * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }

    let subtotal;
    if (calculatedCommissionAmount) {
      subtotal = priceAfterDiscount - calculatedCommissionAmount;
    } else {
      subtotal = priceAfterDiscount;
    }

    if (totalAddonsCost) {
      subtotal += totalAddonsCost;
    }

    const gst = subtotal * 0.05;

    const totalAmount = subtotal + gst;

    const discountPercentage = (discountAmount / basePrice) * 100;

    return {
      basePrice: basePrice.toFixed(2),
      discount: discountAmount.toFixed(2),
      priceAfterDiscount: priceAfterDiscount.toFixed(2),
      gst: gst.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      discountPercentage: discountPercentage,
      // discountType,
      taxAmount: gst.toFixed(2),
      ExtraAdultCost: adultCosts,
      childCosts,
      childCostWithBed,
      childCostWithOutBed,
      totalChildCostPrice,
      adultNumber: guest,
      onlyAdultCost: onlyAdultCost,
      extraAdultNumber: ratesOfPackages?.ExtraAdultCount,
      extraAdultCost: adultCosts,
      childNumber: childAgeArray?.length,

      perPaxCount,
      perPaxCost: (totalAmount / perPaxCount).toFixed(2),
      calculatedAgentAmount: commissionAmt * guest,
      calculatedCommissionAmount,

      agentSavings,
      extraAdultSavings,
      childSavingsWithBed,
      childSavingsWithoutBed,
      subtotal,
    };
  }

  // const handleDiscountChange = (item) => {
  //   if (selectedDiscount?.id === item?.id) {
  //     setSelectedDiscount(null);
  //   } else {
  //     setSelectedDiscount(item);
  //   }
  // };
  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  // useEffect(() => {
  //   if (promotions.length > 0) {
  //     const automaticDiscount = promotions.find(
  //       (promotions) => promotions.promotionType === "automatic"
  //     );
  //     if (automaticDiscount) {
  //       setSelectedDiscount(automaticDiscount);
  //     }
  //   }
  // }, [promotions]);

  const volvoAddonPrice = Array.isArray(singlePackage?.packageAddons)
    ? singlePackage.packageAddons
        .filter(
          (detail) =>
            detail.detail.includes("Volvo") && detail.addonType === "ticket"
        )
        .map((detail) => {
          let calculatedAddonPrice = !detail.perPerson
            ? detail.price
            : Number(detail.price) * Number(childWithAgeLessThanSix);

          if (markupData) {
            const markup = markupData;
            if (markup.markupType === "percentage") {
              calculatedAddonPrice +=
                (calculatedAddonPrice * parseFloat(markup.amount)) / 100;
            } else if (markup.markupType === "fixed") {
              calculatedAddonPrice += parseFloat(markup.amount);
            }
          }
          // if (commissionAmount && commissionType) {
          //   if (commissionType === "percentage") {
          //     calculatedAddonPrice -=
          //       (Number(calculatedAddonPrice) * Number(commissionAmount)) / 100;
          //   } else if (commissionType === "fixed") {
          //     calculatedAddonPrice -= Number(commissionAmount);
          //   }
          // }
          return calculatedAddonPrice;
        })[0]
    : null;

  const calculationsOfPackages = calculateTotalAmount(
    ratesOfPackages?.Price,
    // selectedDiscount?.promotionAmount,
    // selectedDiscount?.promotionMode,
    selectedAutomaticDiscount,
    selectedDiscount,
    // agentDetails?.agent_category_discount
    //   ? agentDetails?.agent_category_discount
    //   : 0,
    // agentDetails?.agent_discount_type
    //   ? agentDetails?.agent_discount_type
    //   : "percentage",
    ratesOfPackages?.NoPax,
    ratesOfPackages,
    bookingData?.childAge ? bookingData?.childAge : [],
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType
  );

  const navigateToCheckOutPackage = () => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");
    navigate(
      `/checkout-package-search/${bookingData?.packageHandle}?packageId=${singlePackage?.packageId}&location=${bookingData?.location}&guest=${bookingData?.guest}&children=${bookingData?.children}${childAgeParams}&checkinDay=${date.setDay}&checkinMonth=${date.setMonth}&checkinYear=${date.setYear}`,
      {
        state: {
          packageData: singlePackage,
          bookingData: bookingData,
          selectedCategory: selectedCategory,
          calculationsOfPackages: calculationsOfPackages,
          selectedAddOns: selectedAddOns,
          customized: false,
          ratesOfPackages,
          markupData,
          selectedMealPlan: selectedMealPlan,
          allPackageHotels: allPackageHotels,
          commission: commission,
          // roomsDetails: roomsDetails,
          totalAddonsCost: totalAddonsCost,
          totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
          selectedAutomaticDiscount: selectedAutomaticDiscount,
          selectedDiscount: selectedDiscount,
        },
      }
    );
  };

  const navigateToCustomizePackage = () => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    navigate(
      `/customize-package/${bookingData?.packagehandle}?packagehandle=${
        bookingData?.packagehandle
      }&location=${bookingData?.location}&guest=${
        bookingData?.guest
      }&children=${
        bookingData?.children ? bookingData?.children : 0
      }${childAgeParams}&checkinDay=${date.setDay}&checkinMonth=${
        date.setMonth
      }&checkinYear=${date.setYear}`,
      {
        state: {
          packageData: singlePackage,
          bookingData: bookingData,
          selectedCategory: selectedCategory,
          calculationsOfPackages: calculationsOfPackages,
        },
      }
    );
  };

  const under6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) < 6
  );
  const over6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) >= 6
  );

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];

    // console.log(checkin, checkout, discountStart, discountEnd);

    return checkin <= discountEnd && checkout >= discountStart;
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 1);
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date();
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDate);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = los;
        valueToCompare = conditionValue;
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };
    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const fetchPromotions = async ({
    checkInDateFromBooking,
    packageIdFromBooking,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPromotions(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";

          const isValidDate = checkDates(item.startDate, item.endDate);

          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBooking,
            checkInDateFromBooking,
            item.startDate,
            item.endDate
          );

          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );

          const blackoutDates = item.promotionBlackOutDate || [];

          const isBlackout = isBlackoutDate(blackoutDates, startDate);

          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "package",
            packageIdFromBooking
          );

          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            startDate
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];

      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      setSelectedAutomaticDiscount(selectedPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/package/${packageId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (packageId && userType === "agent") {
      fetchCommissions();
    }
  }, [packageId, userType]);

  const [isExpanded, setIsExpanded] = useState(true);
  const [isExpandedAddon, setIsExpandedAddon] = useState(false);

  const toggleAccordionAddon = () => {
    setIsExpandedAddon(!isExpandedAddon);
  };

  // const toggleAccordion = () => {
  //   setIsExpanded((prevState) => !prevState);
  // };

  const mapMealPlan = {
    EP: "Room Only",
    CP: "Room with Breakfast",
    MAP: "Room with Breakfast and Dinner",
    AP: "Room with Breakfast, Lunch and Dinner",
  };

  // new
  const groupByCategory = (accommodations) => {
    if (!accommodations) return {};

    const grouped = accommodations.reduce((acc, accommodation) => {
      const category = accommodation.hotelcategory;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(accommodation);
      return acc;
    }, {});

    // Sort the categories to ensure "Deluxe" is first
    const sortedCategories = Object.keys(grouped).sort((a, b) => {
      if (a === selectedCategory) return -1; // Move "Deluxe" to the top
      if (b === selectedCategory) return 1; // Keep "Deluxe" above other categories
      return 0; // Maintain the existing order for others
    });

    // Reconstruct the grouped object with "Deluxe" first

    const newData = sortedCategories.map((category) => {
      return {
        label: category?.toUpperCase(),
        value: category,
      };
    });

    // console.log("newData", newData);
    return newData;

    // return sortedCategories.reduce((sortedAcc, category) => {
    //   sortedAcc[category] = grouped[category];
    //   return sortedAcc;
    // }, {});
  };

  useEffect(() => {
    if (!singlePackage || !selectedCategory || !allPackageHotels) {
      console.error(
        "Missing data: singlePackageData or selectedCategory is undefined."
      );
      return;
    }

    const groupedData = groupByCategory(allPackageHotels);

    if (!groupedData || !groupedData[selectedCategory]) {
      console.error(
        `Error: groupByCategory returned undefined or no data for category ${selectedCategory}.`
      );
      return;
    }

    const selectedArray = groupedData[selectedCategory];

    if (selectedArray.length === 0) {
      console.warn(
        `No data found for the selected category: ${selectedCategory}`
      );
      return;
    }

    // const findMealPlan = selectedArray[0]?.accommodationMealPlan;

    if (selectedMealPlan) {
      // setSelectedMealPlan(selectedMealPlan);
    } else {
      console.warn("No meal plan found in the selected category.");
    }
  }, [selectedCategory, singlePackage]);

  const allCategories = groupByCategory(allPackageHotels);

  return (
    <>
      <PageMetaData
        title={`${
          singlePackage?.packageName &&
          singlePackage?.packageName !== "" &&
          singlePackage?.packageName !== undefined &&
          singlePackage?.packageName
        } - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <OgMetaTitles
        title={`${
          singlePackage?.packageName &&
          singlePackage?.packageName !== "" &&
          singlePackage?.packageName !== undefined &&
          singlePackage?.packageName
        } - Mountain Mysteries`}
        type="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        url={`https://www.mountainmysteries.com/package/${singlePackage?.packagehandle}?location=&guest=2&children=0&packagehandle=${singlePackage?.packagehandle}#package-information`}
      />
      {/* <NewUiHeader /> */}
      {/* <EditNewUiSearchFormHolidays /> */}
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />
          {singlePackage && (
            <>
              {/* Top Section */}
              <div className={styles.section_with_background}>
                <div className={styles.top_container}>
                  {/* Package Main Heading */}
                  <div className={styles.title_container}>
                    <div>
                      {/* Package Name */}
                      <div className={styles.package_name}>
                        {loader ? (
                          <Skeleton width={300} />
                        ) : (
                          <div className="flex flex_gap_10 align_items_center flex_wrap flex_gap_10">
                            <h4>{singlePackage?.packageName}</h4>

                            <div className={`${styles.days_and_night} flex`}>
                              <span className="flex align_items_center">
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_6964_11940"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="14"
                                    height="14"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_6964_11940)">
                                    <path
                                      d="M7.06094 12.5417C6.2854 12.5417 5.55813 12.3945 4.87913 12.1002C4.20003 11.806 3.6077 11.406 3.10215 10.9005C2.59659 10.3949 2.19667 9.80259 1.90238 9.12349C1.60808 8.44449 1.46094 7.71722 1.46094 6.94168C1.46094 5.82061 1.76422 4.79662 2.37079 3.8697C2.97726 2.94269 3.79763 2.26568 4.83188 1.83868C5.01592 1.7609 5.18999 1.77456 5.3541 1.87966C5.51822 1.98466 5.60105 2.13404 5.6026 2.32781C5.61456 3.13922 5.77294 3.91267 6.07773 4.64816C6.38242 5.38374 6.82085 6.03756 7.393 6.60962C7.96506 7.18177 8.61698 7.61927 9.34877 7.92212C10.0806 8.22506 10.8522 8.38251 11.6636 8.39447C11.879 8.39593 12.0372 8.47818 12.1381 8.64122C12.2391 8.80426 12.2508 8.98077 12.173 9.17074C11.7339 10.1991 11.0524 11.018 10.1284 11.6275C9.20449 12.2369 8.18201 12.5417 7.06094 12.5417Z"
                                      fill="#666666"
                                    />
                                  </g>
                                </svg>

                                {`${singlePackage?.totalNights}N`}
                              </span>
                              <span className="flex align_items_center">
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_6964_11945"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="14"
                                    height="14"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_6964_11945)">
                                    <path
                                      d="M6.99644 3.04004C6.87238 3.04004 6.7685 2.99814 6.68479 2.91434C6.60099 2.83043 6.55908 2.7265 6.55908 2.60254V1.32373C6.55908 1.19977 6.60104 1.09589 6.68494 1.01208C6.76884 0.928182 6.87277 0.88623 6.99673 0.88623C7.12079 0.88623 7.22467 0.928182 7.30838 1.01208C7.39218 1.09589 7.43408 1.19977 7.43408 1.32373V2.60254C7.43408 2.7265 7.39213 2.83043 7.30823 2.91434C7.22433 2.99814 7.1204 3.04004 6.99644 3.04004ZM9.7944 4.20219C9.7136 4.12149 9.67413 4.0215 9.67598 3.90221C9.67783 3.78292 9.71915 3.67801 9.79994 3.5875L10.6895 2.67779C10.7773 2.58728 10.8815 2.54202 11.0022 2.54202C11.1228 2.54202 11.2288 2.58767 11.3201 2.67896C11.4038 2.76267 11.4457 2.8647 11.4457 2.98506C11.4457 3.10552 11.4034 3.20799 11.3188 3.29248L10.4091 4.20219C10.3246 4.28677 10.2221 4.32906 10.1017 4.32906C9.98131 4.32906 9.87888 4.28677 9.7944 4.20219ZM11.394 7.4375C11.2701 7.4375 11.1662 7.39555 11.0822 7.31165C10.9984 7.22774 10.9565 7.12381 10.9565 6.99986C10.9565 6.8758 10.9984 6.77192 11.0822 6.68821C11.1662 6.6044 11.2701 6.5625 11.394 6.5625H12.6729C12.7968 6.5625 12.9007 6.60445 12.9845 6.68836C13.0684 6.77226 13.1104 6.87619 13.1104 7.00015C13.1104 7.1242 13.0684 7.22808 12.9845 7.31179C12.9007 7.3956 12.7968 7.4375 12.6729 7.4375H11.394ZM6.99644 13.1138C6.87238 13.1138 6.7685 13.0718 6.68479 12.9879C6.60099 12.9041 6.55908 12.8002 6.55908 12.6763V11.403C6.55908 11.279 6.60104 11.1752 6.68494 11.0914C6.76884 11.0075 6.87277 10.9655 6.99673 10.9655C7.12079 10.9655 7.22467 11.0075 7.30838 11.0914C7.39218 11.1752 7.43408 11.279 7.43408 11.403V12.6763C7.43408 12.8002 7.39213 12.9041 7.30823 12.9879C7.22433 13.0718 7.1204 13.1138 6.99644 13.1138ZM3.58977 4.20219L2.67437 3.30706C2.58386 3.21966 2.5386 3.11403 2.5386 2.99017C2.5386 2.8664 2.58386 2.76228 2.67437 2.67779C2.75886 2.597 2.86255 2.55661 2.98544 2.55661C3.10833 2.55661 3.20953 2.597 3.28906 2.67779L4.20446 3.59319C4.28525 3.67272 4.32565 3.77393 4.32565 3.89681C4.32565 4.0197 4.28564 4.12149 4.20563 4.20219C4.11832 4.28298 4.01648 4.32338 3.9001 4.32338C3.78363 4.32338 3.68019 4.28298 3.58977 4.20219ZM10.6952 11.3222L9.79994 10.4125C9.71915 10.322 9.67783 10.2171 9.67598 10.0978C9.67413 9.9785 9.71322 9.87851 9.79323 9.79781C9.87324 9.71702 9.97328 9.67663 10.0934 9.67663C10.2133 9.67663 10.3186 9.71887 10.4091 9.80336L11.3188 10.6986C11.4056 10.7793 11.4475 10.8808 11.4445 11.0031C11.4415 11.1254 11.399 11.2318 11.3172 11.3222C11.2278 11.4127 11.1217 11.458 10.9988 11.458C10.8758 11.458 10.7746 11.4127 10.6952 11.3222ZM1.32031 7.4375C1.19635 7.4375 1.09247 7.39555 1.00867 7.31165C0.924764 7.22774 0.882812 7.12381 0.882812 6.99986C0.882812 6.8758 0.924764 6.77192 1.00867 6.68821C1.09247 6.6044 1.19635 6.5625 1.32031 6.5625H2.59913C2.72308 6.5625 2.82701 6.60445 2.91092 6.68836C2.99472 6.77226 3.03663 6.87619 3.03663 7.00015C3.03663 7.1242 2.99472 7.22808 2.91092 7.31179C2.82701 7.3956 2.72308 7.4375 2.59913 7.4375H1.32031ZM2.67992 11.3222C2.59913 11.2377 2.55781 11.1343 2.55596 11.012C2.55411 10.8898 2.59358 10.7883 2.67437 10.7075L3.57854 9.80336C3.66303 9.71887 3.76399 9.67663 3.88144 9.67663C3.99879 9.67663 4.10272 9.71848 4.19323 9.80219C4.28374 9.89348 4.329 9.99877 4.329 10.1181C4.329 10.2374 4.28374 10.3422 4.19323 10.4326L3.30365 11.3222C3.21313 11.4127 3.10643 11.458 2.98354 11.458C2.86065 11.458 2.75944 11.4127 2.67992 11.3222ZM6.9979 10.2083C6.10705 10.2083 5.3494 9.89654 4.72494 9.27296C4.10048 8.64938 3.78825 7.89216 3.78825 7.00131C3.78825 6.11047 4.10004 5.35281 4.72363 4.72836C5.34721 4.1039 6.10442 3.79167 6.99527 3.79167C7.88612 3.79167 8.64377 4.10346 9.26823 4.72704C9.89269 5.35063 10.2049 6.10784 10.2049 6.99869C10.2049 7.88954 9.89313 8.64719 9.26954 9.27165C8.64596 9.89611 7.88874 10.2083 6.9979 10.2083Z"
                                      fill="#666666"
                                    />
                                  </g>
                                </svg>

                                {`${singlePackage?.totalDays}D`}
                              </span>
                            </div>
                            <div
                              className={`${styles.starting_location} font_12 flex align_items_center`}
                            >
                              <span className="flex align_items_center">
                                <SvgLocation />
                              </span>
                              {singlePackage?.packageHub}
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className={`${styles.about_package} flex justify_content_between align_items_center px-10`}
                      >
                        {loader ? (
                          <div className="overview-content loading-filter-main">
                            <div className={styles.all_destinations_card}>
                              <b>
                                <Skeleton width={500} />
                              </b>
                            </div>
                          </div>
                        ) : (
                          <div className={styles.all_destinations_wrapper}>
                            {allDestinations &&
                              allDestinations.length > 0 &&
                              allDestinations.map((item, index) => (
                                <div
                                  key={index}
                                  className={styles.all_destinations_card}
                                >
                                  <span>{item.night}N</span> {item.destination}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {loader ? (
                      <div className={styles.options_btns_wrapper}>
                        <div className={styles.options_btns_card}>
                          <Skeleton width={40} />
                        </div>
                        <div className={styles.options_btns_card}>
                          <Skeleton width={40} />
                        </div>
                        <div className={styles.options_btns_card}>
                          <Skeleton width={40} />
                        </div>
                      </div>
                    ) : (
                      <div className={styles.options_btns_wrapper}>
                        <div className={styles.options_btns_card}>
                          <span>
                            {/* <PackageDetails
                              packageData={singlePackage}
                              setOpenGetQuotePopup={setOpenGetQuotePopup}
                              selectedCategory={selectedCategory}
                              allPackageHotels={allPackageHotels}
                              selectedMealPlan={selectedMealPlan}
                            /> */}

                            <NewDownloadPdfButton
                              packageData={singlePackage}
                              // setOpenGetQuotePopup={setOpenGetQuotePopup}
                              selectedCategory={selectedCategory}
                              allPackageHotels={allPackageHotels}
                              selectedMealPlan={selectedMealPlan}
                            />
                          </span>
                        </div>

                        <div className={styles.vertical_line}></div>

                        <div className={styles.options_btns_card}>
                          <NewShare singlePackageData={singlePackage} />
                        </div>
                        <div className={styles.vertical_line}></div>
                        <div className={styles.options_btns_card}>
                          {/* <NewPrint packageData={singlePackage} /> */}

                          <NewUIPackagePrint
                            packageData={singlePackage}
                            selectedCategory={selectedCategory}
                            allPackageHotels={allPackageHotels}
                            selectedMealPlan={selectedMealPlan}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <SinglePackageSearchForm packageData={singlePackage} />
                  {/* Filter Section */}
                  <div className={`${styles.filter_section}`}>
                    <div className={styles.container_inside}>
                      <div className={styles.filter_wrapper}>
                        {mainFilters.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => handleScrollToSection(item.value)}
                            className={`${styles.filter_card} ${
                              filter === item.value ? styles.active_filter : ""
                            }`}
                          >
                            {item.label}
                          </div>
                        ))}{" "}
                      </div>
                    </div>
                  </div>
                </div>

                {/*  */}
                <div className={` ${styles.main_details_section}`}>
                  <div className={styles.container_withoutBg}>
                    <div className={styles.main_details}>
                      {/* Left Section */}
                      <div className={styles.left_wrapper}>
                        {/* Details Itinerary */}
                        {singlePackage?.packageItinerary?.length > 0 && (
                          <div
                            id="detailed_itinerary"
                            className={`${styles.left_wrapper_inner} ${styles.scroll_section} ${styles.detailed_itinerary}`}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() =>
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("detailed_itinerary")) {
                                    return prev.filter(
                                      (item) => item !== "detailed_itinerary"
                                    );
                                  } else {
                                    return [...prev, "detailed_itinerary"];
                                  }
                                })
                              }
                            >
                              <h6>Detailed Itinerary</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes(
                                    "detailed_itinerary"
                                  )
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>

                            {/* <div className={styles.detailed_itinerary_filter}>
                        {detailedItinerary.map((item, index) => (
                          <div
                            className={`${styles.detailed_itinerary_filter_card
                              } ${detailedFilter === item.value ? styles.active : ""
                              }`}
                            onClick={() => handleDetailedFilter(item.value)}
                            key={index}
                          >
                            {item.label}
                          </div>
                        ))}
                      </div> */}

                            {openOuterAccordion.includes(
                              "detailed_itinerary"
                            ) && (
                              <div
                                className={
                                  styles.detailed_itinerary_overview_content
                                }
                              >
                                {singlePackage?.packageItinerary?.length > 0 &&
                                  singlePackage?.packageItinerary.map(
                                    (item, index) => (
                                      <div
                                        className={
                                          styles.detailed_itinerary_overview_content_card
                                        }
                                      >
                                        <div
                                          style={{
                                            border:
                                              openIndex === index
                                                ? "0.5px solid #009A50"
                                                : "0.5px solid #ccc",
                                          }}
                                          onClick={() => toggleAccordion(index)}
                                          className={`${styles.detailed_itinerary_overview_content_card_top} pointer`}
                                        >
                                          <div
                                            className={
                                              styles.detailed_itinerary_overview_content_card_heading
                                            }
                                          >
                                            <span>Day {index + 1}</span>

                                            <div
                                              className={
                                                styles.detailed_itinerary_overview_content_card_heading_inner_parent
                                              }
                                            >
                                              <div
                                                className={
                                                  styles.detailed_itinerary_overview_content_card_heading_right_upper
                                                }
                                              >
                                                {item?.startDestination} to{" "}
                                                {item?.endDestination}
                                              </div>
                                              <div
                                                className={
                                                  styles.details_itinerary_start_end_destination
                                                }
                                              >
                                                Starts At:{" "}
                                                {item?.startDestination} | Ends
                                                At: {item?.endDestination}
                                              </div>
                                            </div>
                                          </div>
                                          <span
                                            className={`${
                                              styles.accordion_icon
                                            } ${
                                              openIndex === index
                                                ? styles.active
                                                : ""
                                            }`}
                                          >
                                            <SvgAccordion />
                                          </span>
                                        </div>

                                        <div
                                          className={`
                                  ${
                                    styles.detailed_itinerary_overview_content_card_bottom
                                  } ${openIndex === index ? styles.open : ""}
                                `}
                                        >
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                item?.additionalDetails
                                                  ?.short_description,
                                            }}
                                          ></p>
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                item?.additionalDetails
                                                  ?.long_description,
                                            }}
                                          ></p>
                                        </div>
                                      </div>
                                    )
                                  )}
                              </div>
                            )}
                          </div>
                        )}

                        {/* stays */}
                        {allPackageHotels && allPackageHotels.length > 0 && (
                          <div
                            id="stays"
                            className={`${styles.left_wrapper_inner} ${styles.scroll_section} ${styles.detailed_itinerary}`}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() => {
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("stays")) {
                                    return prev.filter(
                                      (item) => item !== "stays"
                                    );
                                  } else {
                                    return [...prev, "stays"];
                                  }
                                });
                              }}
                            >
                              <h6>Stays</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes("stays")
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>

                            {openOuterAccordion.includes("stays") && (
                              <div
                                style={{ paddingTop: "10px" }}
                                className={styles.detailed_itinerary_categories}
                              >
                                <NewUiSinglePackageAccommodation
                                  singlePackage={singlePackage}
                                  selectedCategory={selectedCategory}
                                  setSelectedCategory={setSelectedCategory}
                                  loader={loader}
                                  setSelectedMealPlan={setSelectedMealPlan}
                                  selectedMealPlan={selectedMealPlan}
                                  allPackageHotels={allPackageHotels}
                                  packageRates={packageRates}
                                  ratesOfPackages={ratesOfPackages}
                                />
                              </div>
                            )}
                          </div>
                        )}

                        {/* Inclusions / Exclusions */}
                        {singlePackage?.packagePolicies?.length > 0 && (
                          <div
                            id="inclusion_exclusion"
                            className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() => {
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("inclusion_exclusion")) {
                                    return prev.filter(
                                      (item) => item !== "inclusion_exclusion"
                                    );
                                  } else {
                                    return [...prev, "inclusion_exclusion"];
                                  }
                                });
                              }}
                            >
                              <h6>Inclusions / Exclusions</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes(
                                    "inclusion_exclusion"
                                  )
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>
                            {openOuterAccordion.includes(
                              "inclusion_exclusion"
                            ) && (
                              <div
                                className={styles.inclusion_exclusion_content}
                                style={{
                                  borderTop: "1px solid #ccc",
                                  marginTop: "10px",
                                }}
                              >
                                <div className={styles.inclusion_content}>
                                  {singlePackage?.packagePolicies?.length > 0 &&
                                    singlePackage?.packagePolicies
                                      .filter(
                                        (item) => item.type === "inclusion"
                                      )
                                      .map((item, index) => (
                                        <>
                                          <div
                                            className={
                                              styles.inclusion_content_heading
                                            }
                                          >
                                            Inclusions
                                          </div>

                                          <div
                                            key={index}
                                            className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                            dangerouslySetInnerHTML={{
                                              __html: item?.content,
                                            }}
                                          ></div>
                                        </>
                                      ))}
                                </div>
                                <div className={styles.exclusion_content}>
                                  {singlePackage?.packagePolicies?.length > 0 &&
                                    singlePackage?.packagePolicies
                                      .filter(
                                        (item) => item.type === "exclusion"
                                      )
                                      .map((item, index) => (
                                        <>
                                          <div
                                            className={
                                              styles.exclusion_content_heading
                                            }
                                          >
                                            Exclusive
                                          </div>
                                          <div
                                            key={index}
                                            className={`${styles.inner_common_content} ${styles.exclusive_inner_content}`}
                                            dangerouslySetInnerHTML={{
                                              __html: item?.content,
                                            }}
                                          ></div>
                                        </>
                                      ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Points To Remember */}
                        {singlePackage?.packagePolicies?.filter(
                          (item) => item.type === "points_to_remember"
                        )?.length > 0 && (
                          <div
                            id="points_to_remember"
                            // className={styles.left_wrapper_inner}
                            className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() => {
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("points_to_remember")) {
                                    return prev.filter(
                                      (item) => item !== "points_to_remember"
                                    );
                                  } else {
                                    return [...prev, "points_to_remember"];
                                  }
                                });
                              }}
                            >
                              <h6>Things to Know</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes(
                                    "points_to_remember"
                                  )
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>
                            {openOuterAccordion.includes(
                              "points_to_remember"
                            ) && (
                              <div
                                className={styles.inner_common_content_style}
                                style={{
                                  borderTop: "1px solid #ccc",
                                  marginTop: "10px",
                                }}
                              >
                                {singlePackage?.packagePolicies?.length > 0 &&
                                  singlePackage.packagePolicies
                                    .filter(
                                      (item) =>
                                        item.type === "points_to_remember"
                                    )
                                    .map((item, index) => (
                                      <div
                                        key={index}
                                        className={styles.inner_common_content}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    ))}
                              </div>
                            )}
                          </div>
                        )}

                        {/* Terms & Conditions */}
                        {singlePackage?.packagePolicies?.filter(
                          (item) => item.type === "terms_and_conditions"
                        )?.length > 0 && (
                          <div
                            id="terms_and_conditions"
                            className={styles.left_wrapper_inner}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() => {
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("terms_and_conditions")) {
                                    return prev.filter(
                                      (item) => item !== "terms_and_conditions"
                                    );
                                  } else {
                                    return [...prev, "terms_and_conditions"];
                                  }
                                });
                              }}
                            >
                              <h6>Terms & Conditions</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes(
                                    "terms_and_conditions"
                                  )
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>

                            {openOuterAccordion.includes(
                              "terms_and_conditions"
                            ) && (
                              <div
                                className={styles.inner_common_content_style}
                                style={{
                                  borderTop: "1px solid #ccc",
                                  marginTop: "10px",
                                }}
                              >
                                {singlePackage?.packagePolicies?.length > 0 &&
                                  singlePackage.packagePolicies
                                    .filter(
                                      (item) =>
                                        item.type === "terms_and_conditions"
                                    )
                                    .map((item, index) => (
                                      <div
                                        key={index}
                                        className={styles.inner_common_content}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    ))}
                              </div>
                            )}
                          </div>
                        )}

                        {/* Cancellation Policy */}
                        {singlePackage?.packagePolicies?.filter(
                          (item) => item.type === "cancellation_policy"
                        )?.length > 0 && (
                          <div
                            id="cancellation_policy"
                            className={styles.left_wrapper_inner}
                          >
                            <div
                              className={styles.parent_div}
                              onClick={() => {
                                setOpenOuterAccordion((prev) => {
                                  if (prev.includes("cancellation_policy")) {
                                    return prev.filter(
                                      (item) => item !== "cancellation_policy"
                                    );
                                  } else {
                                    return [...prev, "cancellation_policy"];
                                  }
                                });
                              }}
                            >
                              <h6>Cancellation Policy</h6>

                              <span
                                className={`${styles.accordion_icon} ${
                                  openOuterAccordion.includes(
                                    "cancellation_policy"
                                  )
                                    ? styles.active
                                    : ""
                                }`}
                              >
                                <SvgAccordion />
                              </span>
                            </div>

                            {openOuterAccordion.includes(
                              "cancellation_policy"
                            ) && (
                              <div
                                className={`${styles.inner_common_content_style}`}
                                style={{
                                  borderTop: "1px solid #ccc",
                                  marginTop: "10px",
                                }}
                              >
                                {singlePackage?.packagePolicies?.length > 0 &&
                                  singlePackage.packagePolicies
                                    .filter(
                                      (item) =>
                                        item.type === "cancellation_policy"
                                    )
                                    .map((item, index) => (
                                      <div
                                        key={index}
                                        className={styles.inner_common_content}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Right Section */}
                      <div className={styles.right_wrapper}>
                        <aside
                          className={` ${styles.price_breakup_aside}`}
                          style={{
                            width: "100%",
                            background: "#fff",
                            border: "0.5px solid #aaa",
                            borderRadius: "15px",
                            overflow: "hidden",
                          }}
                          id="Price-Break"
                        >
                          <div className="common_background common_background_parent_sticky m_0">
                            {singlePackage &&
                              singlePackage?.packageRates &&
                              singlePackage?.packageRates.length > 0 && (
                                <div
                                  style={{
                                    padding: "10px",
                                    borderBottom: "0.5px solid #ccc",
                                  }}
                                >
                                  <label>Select Accommodation</label>
                                  <select
                                    className="w-full"
                                    name="meal_plan"
                                    value={selectedCategory}
                                    onChange={(e) =>
                                      setSelectedCategory(e.target.value)
                                    }
                                  >
                                    <option value="">Select an option</option>
                                    {allCategories.map((category) => (
                                      <option
                                        key={category?.value}
                                        value={category?.value}
                                      >
                                        {category?.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}
                            {/* <hr />  */}
                            {singlePackage &&
                              singlePackage?.packageRates &&
                              singlePackage?.packageRates.length > 0 && (
                                <div
                                  style={{
                                    padding: "10px",
                                    // borderBottom: "0.5px solid #ccc",
                                  }}
                                >
                                  <label>Select Meal Plan</label>
                                  <select
                                    className="w-full"
                                    name="meal_plan"
                                    value={selectedMealPlan}
                                    onChange={(e) =>
                                      setSelectedMealPlan(e.target.value)
                                    }
                                  >
                                    <option value="">Select an option</option>
                                    {Array.from(
                                      new Set(
                                        singlePackage?.packageRates.map(
                                          (rate) => rate.mealPlan
                                        )
                                      )
                                    )
                                      .sort((a, b) => {
                                        const order = ["ep", "cp", "map", "ap"];
                                        return (
                                          order.indexOf(a) - order.indexOf(b)
                                        );
                                      })
                                      .map((mealPlan) => (
                                        <option key={mealPlan} value={mealPlan}>
                                          {mapMealPlan[mealPlan?.toUpperCase()]}
                                          {"  "}({mealPlan.toUpperCase()})
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              )}

                            {singlePackage?.packageAddons &&
                              singlePackage?.packageAddons.length > 0 && (
                                <div
                                  className={`${styles.addons_container} ${styles.desktop_addon}`}
                                >
                                  <div
                                    className="flex align_items_center justify_content_between pointer"
                                    onClick={toggleAccordionAddon}
                                  >
                                    <h5 style={{ color: "#333" }}>Add Ons</h5>
                                    <svg
                                      width="25px"
                                      height="25px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        cursor: "pointer",
                                        transform: isExpandedAddon
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                      }}
                                    >
                                      <path
                                        d="M7 10L12 15L17 10"
                                        stroke="#016937"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  <div
                                    className="overflow-width"
                                    style={{
                                      display: isExpandedAddon
                                        ? "block"
                                        : "none",
                                    }}
                                  >
                                    {singlePackage.packageAddons
                                      .filter(
                                        (item) =>
                                          !item.detail.includes("Volvo") &&
                                          item.addonType !== "ticket"
                                      )
                                      .map((item, index) => {
                                        let finalAddonPrice = item?.price;
                                        let priceWithMarkup = item?.price;

                                        if (markupData) {
                                          const markup = markupData;
                                          if (
                                            markup.markupType === "percentage"
                                          ) {
                                            finalAddonPrice +=
                                              (item.price *
                                                parseFloat(markup.amount)) /
                                              100;
                                          } else if (
                                            markup.markupType === "fixed"
                                          ) {
                                            finalAddonPrice += parseFloat(
                                              markup.amount
                                            );
                                          }
                                        }
                                        priceWithMarkup = finalAddonPrice;

                                        if (
                                          commission?.commissionAmount &&
                                          commission?.commissionType
                                        ) {
                                          if (
                                            commission?.commissionType ===
                                            "percentage"
                                          ) {
                                            finalAddonPrice -=
                                              (Number(finalAddonPrice) *
                                                Number(
                                                  commission?.commissionAmount
                                                )) /
                                              100;
                                          } else if (
                                            commission?.commissionType ===
                                            "fixed"
                                          ) {
                                            finalAddonPrice = Number(
                                              commission?.commissionAmount
                                            );
                                          }
                                        }

                                        return (
                                          <div
                                            key={index}
                                            className={`${
                                              styles.addon_inner_card
                                            } ${
                                              selectedAddOns.some(
                                                (addon) => addon.id === item.id
                                              )
                                                ? styles.selected
                                                : ""
                                            } flex justify_content_between w-100 mt-7`}
                                          >
                                            <div
                                              style={{
                                                cursor: "pointer",
                                                width: "80%",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontSize: "15px",
                                                  fontWeight: 500,
                                                }}
                                              >
                                                <span className="font_12">
                                                  {item.detail}
                                                </span>{" "}
                                                {commission?.commissionAmount &&
                                                  commission?.commissionType && (
                                                    <span
                                                      className={`${
                                                        selectedAddOns.some(
                                                          (addon) =>
                                                            addon.id === item.id
                                                        )
                                                          ? styles.selected_price
                                                          : ""
                                                      }`}
                                                      style={{
                                                        fontSize: "12px",
                                                        color: "red",
                                                        textDecoration:
                                                          "line-through",
                                                      }}
                                                    >
                                                      {formatIndianCurrency(
                                                        priceWithMarkup
                                                      )}{" "}
                                                      {item.perPerson
                                                        ? `* ${guest}`
                                                        : ""}
                                                    </span>
                                                  )}
                                                <span
                                                  className={`${
                                                    styles.addon_price
                                                  } ${
                                                    selectedAddOns.some(
                                                      (addon) =>
                                                        addon.id === item.id
                                                    )
                                                      ? styles.selected_price
                                                      : ""
                                                  }`}
                                                >
                                                  {formatIndianCurrency(
                                                    finalAddonPrice
                                                  )}{" "}
                                                  {item.perPerson
                                                    ? `* ${guest}`
                                                    : ""}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="">
                                              <button
                                                style={{ fontSize: "10px" }}
                                                onClick={() =>
                                                  handleSelectedAddOns({
                                                    ...item,
                                                    finalAddonPrice,
                                                    priceWithMarkup,
                                                  })
                                                }
                                              >
                                                {selectedAddOns.some(
                                                  (addon) =>
                                                    addon.id === item.id
                                                ) ? (
                                                  <div style={{ color: "red" }}>
                                                    <CrossWithBorder />
                                                  </div>
                                                ) : (
                                                  <div
                                                    style={{
                                                      background: "#009A50",
                                                      color: "#fff",
                                                      padding: "5px 7px",
                                                    }}
                                                  >
                                                    ADD
                                                  </div>
                                                )}
                                              </button>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              )}

                            <div
                              className="flex justify_content_between align_items_center pointer"
                              onClick={() => {
                                handleButtonClick();
                                togglePaymentDetails();
                              }}
                              style={{
                                padding: "10px 10px",
                                backgroundColor: "#E8F9F1",
                              }}
                            >
                              <h4 style={{ fontSize: "16px" }}>
                                Price Breakup
                              </h4>
                              <div style={{ backgroundColor: "#E8F9F1" }}>
                                <button
                                  className={`${
                                    activePayment === "priceSummary" ? "" : ""
                                  }`}
                                >
                                  {/* <small className="link_btn">
                                {activePayment === "priceSummary"
                                  ? "Minimize Breakup"
                                  : "View Breakup"}{" "}
                              </small> */}
                                  {/* <svg
                                width="13"
                                height="8"
                                viewBox="0 0 13 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  transition: "transform 0.3s",
                                  transform: paymentDetails
                                    ? "rotate(0deg)"
                                    : "rotate(180deg)",
                                }}
                              >
                                <path
                                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                  stroke="#222222"
                                  strokeWidth="1.5"
                                />
                              </svg> */}

                                  {paymentDetails ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_6868_15102"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="19"
                                      >
                                        <rect
                                          y="0.5"
                                          width="18"
                                          height="18"
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_6868_15102)">
                                        <path
                                          d="M4.38462 14.1154H7.38462C7.58077 14.1154 7.74523 14.1818 7.878 14.3145C8.01062 14.4473 8.07692 14.6118 8.07692 14.8079C8.07692 15.0042 8.01062 15.1686 7.878 15.3011C7.74523 15.4337 7.58077 15.5 7.38462 15.5H3.83446C3.598 15.5 3.39985 15.42 3.24 15.26C3.08 15.1002 3 14.902 3 14.6655V11.1154C3 10.9192 3.06638 10.7548 3.19915 10.622C3.33192 10.4894 3.49638 10.4231 3.69254 10.4231C3.88885 10.4231 4.05323 10.4894 4.18569 10.622C4.31831 10.7548 4.38462 10.9192 4.38462 11.1154V14.1154ZM13.6154 4.88462H10.6154C10.4192 4.88462 10.2548 4.81823 10.122 4.68546C9.98938 4.55269 9.92308 4.38823 9.92308 4.19208C9.92308 3.99577 9.98938 3.83138 10.122 3.69892C10.2548 3.56631 10.4192 3.5 10.6154 3.5H14.1655C14.402 3.5 14.6002 3.58 14.76 3.74C14.92 3.89985 15 4.098 15 4.33446V7.88462C15 8.08077 14.9336 8.24523 14.8008 8.378C14.6681 8.51062 14.5036 8.57692 14.3075 8.57692C14.1112 8.57692 13.9468 8.51062 13.8143 8.378C13.6817 8.24523 13.6154 8.08077 13.6154 7.88462V4.88462Z"
                                          fill="#1C1B1F"
                                        />
                                      </g>
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_6868_15096"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="18"
                                        height="19"
                                      >
                                        <rect
                                          y="0.5"
                                          width="18"
                                          height="18"
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_6868_15096)">
                                        <path
                                          d="M6.69231 11.8077H3.69231C3.49615 11.8077 3.33177 11.7413 3.19915 11.6085C3.06638 11.4758 3 11.3113 3 11.1152C3 10.9188 3.06638 10.7545 3.19915 10.622C3.33177 10.4894 3.49615 10.4231 3.69231 10.4231H7.24269C7.479 10.4231 7.67715 10.503 7.83715 10.6628C7.997 10.8228 8.07692 11.021 8.07692 11.2573V14.8077C8.07692 15.0038 8.01054 15.1682 7.87777 15.3008C7.745 15.4336 7.58054 15.5 7.38438 15.5C7.18808 15.5 7.02369 15.4336 6.89123 15.3008C6.75862 15.1682 6.69231 15.0038 6.69231 14.8077V11.8077ZM11.3077 7.19231H14.3077C14.5038 7.19231 14.6682 7.25869 14.8008 7.39146C14.9336 7.52423 15 7.68869 15 7.88485C15 8.08115 14.9336 8.24554 14.8008 8.378C14.6682 8.51062 14.5038 8.57692 14.3077 8.57692H10.7573C10.521 8.57692 10.3228 8.497 10.1628 8.33715C10.003 8.17715 9.92308 7.979 9.92308 7.74269V4.19231C9.92308 3.99615 9.98946 3.83177 10.1222 3.69915C10.255 3.56638 10.4195 3.5 10.6156 3.5C10.8119 3.5 10.9763 3.56638 11.1088 3.69915C11.2414 3.83177 11.3077 3.99615 11.3077 4.19231V7.19231Z"
                                          fill="#1C1B1F"
                                        />
                                      </g>
                                    </svg>
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                padding: "10px",
                                paddingTop: "0",
                                background: "#E8F9F1",
                              }}
                            >
                              <>
                                {activePayment === "priceSummary" && (
                                  <>
                                    <div className="flex justify_content_between ">
                                      <p>
                                        Adult Cost{" "}
                                        <small>
                                          (
                                          {calculationsOfPackages?.onlyAdultCost /
                                            calculationsOfPackages?.adultNumber}{" "}
                                          X{" "}
                                          {calculationsOfPackages?.adultNumber})
                                        </small>
                                      </p>
                                      <span
                                        className={`room_text-right ${
                                          Number(
                                            calculationsOfPackages?.onlyAdultCost
                                          ) <= 0 && "filterBlur3"
                                        }`}
                                      >
                                        {priceLoader ? (
                                          <Skeleton
                                            width={80}
                                            height={10}
                                            borderRadius={4}
                                          />
                                        ) : (
                                          <>
                                            {formatIndianCurrency(
                                              calculationsOfPackages?.onlyAdultCost
                                            )}
                                          </>
                                        )}
                                      </span>
                                    </div>

                                    {calculationsOfPackages?.extraAdultNumber >
                                      0 &&
                                    calculationsOfPackages?.ExtraAdultCost ? (
                                      <div className="flex justify_content_between mt-7">
                                        <p>
                                          Extra Adult Cost{" "}
                                          <small>
                                            (
                                            {calculationsOfPackages?.ExtraAdultCost /
                                              calculationsOfPackages?.extraAdultNumber}{" "}
                                            X{" "}
                                            {
                                              calculationsOfPackages?.extraAdultNumber
                                            }
                                            )
                                          </small>
                                        </p>
                                        <span
                                          className={`room_text-right ${
                                            Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <>
                                              {formatIndianCurrency(
                                                calculationsOfPackages?.ExtraAdultCost
                                              )}
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    ) : null}

                                    {under6AgeChildren?.length > 0 &&
                                    calculationsOfPackages?.childNumber > 0 &&
                                    calculationsOfPackages?.childCostWithOutBed ? (
                                      <div className="flex justify_content_between mt-7">
                                        <p>
                                          Child Cost ({`< 6 yrs`}){" "}
                                          <small>
                                            ̀ (
                                            {/* {commission && Object.keys(commission).length > 0 && (
                                                    <span style={{ color: 'red', textDecoration: 'line-through' }}>
                                                      {(calculationsOfPackages?.childCostWithOutBed /
                                                        under6AgeChildren.length) +
                                                        calculationsOfPackages?.childSavingsWithoutBed}
                                                      {" "}
                                                    </span>
                                                  )} */}
                                            {/* {calculationsOfPackages?.childCostWithOutBed /
                                                    under6AgeChildren.length}{" "} */}
                                            {Math.round(
                                              calculationsOfPackages?.childCostWithOutBed /
                                                under6AgeChildren.length
                                            )}
                                            X {under6AgeChildren.length})
                                          </small>
                                        </p>
                                        <span
                                          className={`room_text-right ${
                                            Number(
                                              calculationsOfPackages?.childCostWithOutBed
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.childCostWithOutBed
                                          )}
                                        </span>
                                      </div>
                                    ) : null}

                                    {over6AgeChildren?.length > 0 &&
                                    calculationsOfPackages?.childNumber > 0 &&
                                    calculationsOfPackages?.childCostWithBed ? (
                                      <div className="flex justify_content_between mt-7">
                                        <p>
                                          Child Cost ({`>= 6 yrs`}){" "}
                                          <small>
                                            ̀ (
                                            {/* {commission && Object.keys(commission).length > 0 && (
                                                    <span style={{ color: 'red', textDecoration: 'line-through' }}>
                                                      {(calculationsOfPackages?.childCostWithBed /
                                                        under6AgeChildren.length) +
                                                        calculationsOfPackages?.childSavingsWithBed}
                                                      {" "}
                                                    </span>
                                                  )} */}
                                            {calculationsOfPackages?.childCostWithBed /
                                              over6AgeChildren.length}{" "}
                                            X {over6AgeChildren.length})
                                          </small>
                                        </p>
                                        <span
                                          className={`room_text-right ${
                                            Number(
                                              calculationsOfPackages?.childCostWithBed
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <>
                                              {formatIndianCurrency(
                                                calculationsOfPackages?.childCostWithBed
                                              )}
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    ) : null}
                                  </>
                                )}

                                <div className="flex justify_content_between mt-7">
                                  <h6>Total Package Cost</h6>
                                  <span
                                    className={` ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    <b>
                                      {" "}
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.basePrice
                                          )}
                                        </>
                                      )}
                                    </b>
                                  </span>
                                </div>

                                {activePayment === "priceSummary" && (
                                  <>
                                    {(selectedAutomaticDiscount?.length > 0 ||
                                      selectedDiscount?.length > 0) && (
                                      <div
                                        className="mt-7 pt_10"
                                        style={{
                                          borderTop: "0.5px solid #ccc",
                                        }}
                                      >
                                        <p>
                                          <b>
                                            Package Discount
                                            {selectedAutomaticDiscount?.length >
                                            1
                                              ? "s"
                                              : ""}
                                          </b>
                                        </p>
                                        {selectedAutomaticDiscount?.map(
                                          (discount, index) => (
                                            <div
                                              className="flex justify_content_between mt-2"
                                              key={discount.id}
                                            >
                                              <span className="discount-name">
                                                {discount.promotionName}
                                              </span>
                                              <span className="room_text-right green">
                                                {discount.promotionMode ===
                                                "percentage"
                                                  ? `${+discount.promotionAmount}%`
                                                  : `${formatIndianCurrency(
                                                      discount.promotionAmount
                                                    )}`}
                                              </span>
                                            </div>
                                          )
                                        )}

                                        {selectedDiscount &&
                                          selectedDiscount?.length > 0 &&
                                          selectedDiscount?.map(
                                            (discount, index) => (
                                              <div
                                                className="flex justify_content_between mt-2"
                                                key={discount.id}
                                              >
                                                <span className="discount-name">
                                                  {discount.promotionName}
                                                </span>
                                                <span className="room_text-right green">
                                                  {discount.promotionMode ===
                                                  "percentage"
                                                    ? `${+discount.promotionAmount}%`
                                                    : `${formatIndianCurrency(
                                                        discount.promotionAmount
                                                      )}`}
                                                </span>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    )}

                                    {calculationsOfPackages?.discount > 0 && (
                                      <div
                                        className="flex justify_content_between mt-7 border-bottom-one "
                                        style={{ paddingBottom: "7px" }}
                                      >
                                        <p>Package Cost (After Disc.)</p>
                                        <span
                                          className={`room_text-right ${
                                            Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.priceAfterDiscount
                                          )}
                                        </span>
                                      </div>
                                    )}

                                    {commission &&
                                      Object.keys(commission)?.length > 0 && (
                                        <>
                                          <div className="flex justify_content_between mt-7">
                                            <p>
                                              Commission{" "}
                                              <small>
                                                ({" "}
                                                {commission.commissionType ===
                                                "fixed" ? (
                                                  <span className="room_text-right">
                                                    {formatIndianCurrency(
                                                      commission?.commissionAmount
                                                    )}
                                                  </span>
                                                ) : (
                                                  <span className="room_text-right">
                                                    {
                                                      commission?.commissionAmount
                                                    }
                                                    %
                                                  </span>
                                                )}
                                                )
                                              </small>
                                            </p>

                                            {formatIndianCurrency(
                                              calculationsOfPackages?.calculatedCommissionAmount
                                            )}
                                          </div>
                                        </>
                                      )}

                                    <div className="flex justify_content_between mt-7">
                                      <p>Subtotal </p>

                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.subtotal
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </>
                                )}

                                {selectedAddOns &&
                                  selectedAddOns?.length > 0 && (
                                    <div className="flex justify_content_between mt-7">
                                      <p>Addons Price</p>
                                      <span
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "end",
                                        }}
                                      >
                                        {commission &&
                                          Object.keys(commission).length >
                                            0 && (
                                            <small
                                              style={{
                                                color: "red",
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              {formatIndianCurrency(
                                                totalAddonsCostWithoutCommission
                                              )}
                                            </small>
                                          )}
                                        <b>
                                          {formatIndianCurrency(
                                            totalAddonsCost
                                          )}
                                        </b>
                                      </span>
                                    </div>
                                  )}

                                <div
                                  className="flex justify_content_between mt-7 border-bottom-one "
                                  style={{ paddingBottom: "7px" }}
                                >
                                  <p>GST(5%) </p>
                                  <span
                                    className={`room_text-right  ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {priceLoader ? (
                                      <Skeleton
                                        width={80}
                                        height={10}
                                        borderRadius={4}
                                      />
                                    ) : (
                                      <>
                                        {formatIndianCurrency(
                                          calculationsOfPackages?.taxAmount
                                        )}
                                      </>
                                    )}
                                  </span>
                                </div>
                                <div
                                  className="flex justify_content_between mt-7 border-bottom-one "
                                  style={{ paddingBottom: "7px" }}
                                >
                                  <p>Vehicle</p>
                                  <span className="room_text-right">
                                    {priceLoader ? (
                                      <Skeleton
                                        width={80}
                                        height={10}
                                        borderRadius={4}
                                      />
                                    ) : (
                                      <span
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {ratesOfPackages?.VehicleType?.replace(
                                          /-/g,
                                          " "
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </div>
                                <div className="flex justify_content_between mt-7">
                                  <h6>Total Amount to be paid</h6>
                                  <h6>
                                    <span
                                      className={` ${
                                        Number(
                                          calculationsOfPackages?.totalAmount
                                        ) <= 0 && "filterBlur3"
                                      }`}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "end",
                                      }}
                                    >
                                      <b>
                                        {priceLoader ? (
                                          <Skeleton
                                            width={80}
                                            height={10}
                                            borderRadius={4}
                                          />
                                        ) : (
                                          <b>
                                            {formatIndianCurrency(
                                              calculationsOfPackages?.totalAmount
                                            )}
                                          </b>
                                        )}
                                      </b>
                                    </span>
                                  </h6>
                                </div>
                              </>
                              {/* )} */}
                            </div>

                            {promotions?.length > 0 && (
                              <>
                                {promotions.some(
                                  (item) =>
                                    item.promotionType === "coupon" &&
                                    (() => {
                                      const isValidDate = checkDates(
                                        item.startDate,
                                        item.endDate
                                      );
                                      const isBookingWithinDiscount =
                                        checkBookingDates(
                                          startDate,
                                          startDate,
                                          item.startDate,
                                          item.endDate
                                        );
                                      const isUserEligible =
                                        isPromotionApplicable(
                                          userType === "customer"
                                            ? "customers"
                                            : userType === "agent"
                                            ? "agents"
                                            : "",
                                          userDetails?.id,
                                          item.promotionApplicable
                                        );
                                      const blackoutDates =
                                        item.promotionBlackOutDate || [];
                                      const isBlackout = isBlackoutDate(
                                        blackoutDates,
                                        startDate
                                      );
                                      const isApplicableForEntity =
                                        isPromotionApplicableForEntity(
                                          item.promotionEntity,
                                          "package",
                                          singlePackage?.packageId
                                        );
                                      const isConditionsValid =
                                        evaluateConditions(
                                          item.promotionConditions,
                                          startDate
                                        );

                                      return (
                                        isValidDate &&
                                        isBookingWithinDiscount &&
                                        isUserEligible &&
                                        !isBlackout &&
                                        isApplicableForEntity &&
                                        isConditionsValid
                                      );
                                    })()
                                ) && (
                                  <div className={`${styles.discount_wrapper}`}>
                                    <div
                                      className={` flex justify_content_between cursor_pointer`}
                                    >
                                      <div className="flex justify_content_between w-100">
                                        <div>
                                          <h5 className="text-left">
                                            Discounts
                                          </h5>
                                        </div>
                                        {selectedDiscount && (
                                          <button
                                            className="view_btn"
                                            onClick={() =>
                                              setSelectedDiscount([])
                                            }
                                          >
                                            clear
                                          </button>
                                        )}
                                      </div>
                                    </div>

                                    <div>
                                      {promotions?.map((item, index) => {
                                        const isCouponCode =
                                          item?.promotionType === "coupon"
                                            ? true
                                            : false;
                                        const isValidDate = checkDates(
                                          item.startDate,
                                          item.endDate
                                        );
                                        const isBookingWithinDiscount =
                                          checkBookingDates(
                                            startDate,
                                            startDate,
                                            item.startDate,
                                            item.endDate
                                          );
                                        const isUserEligible =
                                          isPromotionApplicable(
                                            userType === "customer"
                                              ? "customers"
                                              : userType === "agent"
                                              ? "agents"
                                              : "",
                                            userDetails?.id,
                                            item.promotionApplicable
                                          );
                                        const blackoutDates =
                                          item.promotionBlackOutDate || [];
                                        const isBlackout = isBlackoutDate(
                                          blackoutDates,
                                          startDate
                                        );
                                        const isApplicableForEntity =
                                          isPromotionApplicableForEntity(
                                            item.promotionEntity,
                                            "package",
                                            singlePackage?.packageId
                                          );

                                        const isConditionsValid =
                                          evaluateConditions(
                                            item.promotionConditions,
                                            startDate
                                          );

                                        return (
                                          isCouponCode &&
                                          isValidDate &&
                                          isBookingWithinDiscount &&
                                          isUserEligible &&
                                          !isBlackout &&
                                          isApplicableForEntity &&
                                          isConditionsValid && (
                                            <div
                                              key={index}
                                              className={`${
                                                styles.discount_card
                                              } ${
                                                selectedDiscount?.some(
                                                  (discount) =>
                                                    discount.id === item.id
                                                )
                                                  ? styles.selectedDiscountCard
                                                  : ""
                                              } w-100`}
                                            >
                                              <div className="flex justify_content_between">
                                                <div className="flex">
                                                  <label
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                    htmlFor={
                                                      item?.promotionName
                                                    }
                                                  >
                                                    {" "}
                                                    <input
                                                      checked={selectedDiscount?.some(
                                                        (discount) =>
                                                          discount.id ===
                                                          item.id
                                                      )}
                                                      onChange={() =>
                                                        handleDiscountChange(
                                                          item
                                                        )
                                                      }
                                                      type="radio"
                                                      id={item.promotionName}
                                                      className={`${
                                                        selectedDiscount?.some(
                                                          (discount) =>
                                                            discount.id ===
                                                            item.id
                                                        )
                                                          ? styles.selectedDiscount_color
                                                          : ""
                                                      }`}
                                                    />
                                                    <div>
                                                      <div
                                                        className={`${
                                                          styles.discount_name
                                                        } ${
                                                          selectedDiscount?.some(
                                                            (discount) =>
                                                              discount.id ===
                                                              item.id
                                                          )
                                                            ? styles.selectedDiscount_color
                                                            : ""
                                                        }`}
                                                      >
                                                        {item?.promotionName?.replace(
                                                          /-/g,
                                                          " "
                                                        )}
                                                      </div>
                                                    </div>
                                                  </label>
                                                </div>
                                                <div>
                                                  {item?.promotionMode ===
                                                  "fixed" ? (
                                                    formatIndianCurrency(
                                                      item?.promotionAmount
                                                    )
                                                  ) : (
                                                    <>
                                                      {item?.promotionAmount}%
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            <div
                              className="buttons flex_direction_col"
                              style={{
                                backgroundColor: "#E8F9F1",
                                marginTop: 0,
                                padding: "0 15px",
                                paddingBottom: "10px",
                              }}
                            >
                              {Number(calculationsOfPackages?.totalAmount) >
                              0 ? (
                                <>
                                  <button
                                    style={{
                                      marginTop: "10px",
                                    }}
                                    onClick={navigateToCheckOutPackage}
                                    className={styles.book_now_btn}
                                  >
                                    Book Now
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                              {/* </Link> */}
                              <button
                                onClick={(e) => handleshowRatePopup(e)}
                                className={styles.get_quote_btn}
                              >
                                Get Quote
                              </button>
                            </div>
                          </div>
                        </aside>

                        {mobilePriceBreakup && (
                          <>
                            <div
                              className={`${styles.mobilePriceBreakup} ${
                                priceBreakupPopup ? styles.open : styles.close
                              } flex justify_content_between total_amount align_items_center`}
                              onClick={() => setPriceBreakupPopup(true)}
                            >
                              <div>
                                <h6 className="font_14 weight_500">
                                  Total Amt.
                                </h6>
                              </div>
                              <div
                                className={` flex flex_gap_10 align_items_center`}
                              >
                                <div>
                                  {" "}
                                  <span
                                    className={`${styles.mobile_bottom_amt} ${
                                      Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                    }`}
                                  >
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.totalAmount
                                    )}{" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_6305_6801"
                                        maskUnits="userSpaceOnUse"
                                        x="0"
                                        y="0"
                                        width="16"
                                        height="17"
                                      >
                                        <rect
                                          y="16.5"
                                          width="16"
                                          height="16"
                                          transform="rotate(-90 0 16.5)"
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_6305_6801)">
                                        <path
                                          d="M7.99977 10.376L13.0216 5.3542C13.154 5.22175 13.31 5.1572 13.4894 5.16053C13.669 5.16397 13.825 5.23192 13.9574 5.36436C14.0899 5.49692 14.1561 5.65292 14.1561 5.83236C14.1561 6.01181 14.0899 6.16781 13.9574 6.30036L8.8536 11.4144C8.73304 11.5349 8.59799 11.6243 8.44843 11.6824C8.29888 11.7405 8.14932 11.7695 7.99977 11.7695C7.85021 11.7695 7.70065 11.7405 7.5511 11.6824C7.40154 11.6243 7.26649 11.5349 7.14593 11.4144L2.03177 6.30036C1.89932 6.16781 1.83482 6.01009 1.83827 5.8272C1.84171 5.64431 1.90965 5.48664 2.0421 5.3542C2.17454 5.22175 2.33054 5.15553 2.5101 5.15553C2.68954 5.15553 2.84549 5.22175 2.97793 5.3542L7.99977 10.376Z"
                                          fill="#009A50"
                                        />
                                      </g>
                                    </svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {priceBreakupPopup && (
                              <div className="bg_back_drop_overlay">
                                <div
                                  className="common_background common_background_parent_sticky"
                                  id="PriceBreak"
                                  style={{ overflow: "scroll" }}
                                >
                                  <div className="flex justify_content_end p_b_10 ">
                                    <svg
                                      onClick={() =>
                                        setPriceBreakupPopup(false)
                                      }
                                      width="14"
                                      height="13"
                                      viewBox="0 0 14 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M1 12.5L13 0.5"
                                        stroke="#AAAAAA"
                                        strokeWidth="1.2"
                                      />
                                      <path
                                        d="M13 12.5L1 0.5"
                                        stroke="#AAAAAA"
                                        strokeWidth="1.2"
                                      />
                                    </svg>
                                  </div>

                                  {singlePackage &&
                                    singlePackage?.packageRates &&
                                    singlePackage?.packageRates.length > 0 && (
                                      <div
                                        style={{
                                          marginBottom: "5px",
                                          borderBottom: "0.5px solid #ccc",
                                        }}
                                      >
                                        <label>Select Accommodation</label>
                                        <select
                                          className="w-full"
                                          name="meal_plan"
                                          value={selectedCategory}
                                          onChange={(e) =>
                                            setSelectedCategory(e.target.value)
                                          }
                                        >
                                          <option value="">
                                            Select an option
                                          </option>
                                          {allCategories.map((category) => (
                                            <option
                                              key={category?.value}
                                              value={category?.value}
                                            >
                                              {category?.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}

                                  {singlePackage &&
                                    singlePackage?.packageRates &&
                                    singlePackage?.packageRates.length > 0 && (
                                      <div>
                                        <label>Select Meal Plan</label>
                                        <select
                                          className="w-full"
                                          name="meal_plan"
                                          value={selectedMealPlan}
                                          onChange={(e) =>
                                            setSelectedMealPlan(e.target.value)
                                          }
                                        >
                                          <option value="" disabled>
                                            Select an option
                                          </option>
                                          {Array.from(
                                            new Set(
                                              singlePackage?.packageRates.map(
                                                (rate) => rate.mealPlan
                                              )
                                            )
                                          ).map((mealPlan) => (
                                            <option
                                              key={mealPlan}
                                              value={mealPlan}
                                            >
                                              {
                                                mapMealPlan[
                                                  mealPlan?.toUpperCase()
                                                ]
                                              }
                                              {/* {mealPlan.toUpperCase()} */}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}

                                  {singlePackage?.packageAddons &&
                                    singlePackage?.packageAddons.length > 0 && (
                                      <div
                                        className={`${styles.addons_container}`}
                                      >
                                        <div
                                          className="flex align_items_center justify_content_between"
                                          onClick={toggleAccordionAddon}
                                        >
                                          <h5 style={{ color: "#333" }}>
                                            Addons
                                          </h5>
                                          <svg
                                            width="25px"
                                            height="25px"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                              cursor: "pointer",
                                              transform: isExpandedAddon
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                              transition: "transform 0.3s ease",
                                            }}
                                          >
                                            <path
                                              d="M7 10L12 15L17 10"
                                              stroke="#016937"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </div>

                                        <div
                                          className="overflow-width"
                                          style={{
                                            display: isExpandedAddon
                                              ? "block"
                                              : "none",
                                          }}
                                        >
                                          {singlePackage.packageAddons
                                            .filter(
                                              (item) =>
                                                !item.detail.includes(
                                                  "Volvo"
                                                ) && item.addonType !== "ticket"
                                            )
                                            .map((item, index) => {
                                              let finalAddonPrice = item?.price;
                                              let priceWithMarkup = item?.price;

                                              if (markupData) {
                                                const markup = markupData;
                                                if (
                                                  markup.markupType ===
                                                  "percentage"
                                                ) {
                                                  finalAddonPrice +=
                                                    (item.price *
                                                      parseFloat(
                                                        markup.amount
                                                      )) /
                                                    100;
                                                } else if (
                                                  markup.markupType === "fixed"
                                                ) {
                                                  finalAddonPrice += parseFloat(
                                                    markup.amount
                                                  );
                                                }
                                              }
                                              priceWithMarkup = finalAddonPrice;

                                              if (
                                                commission?.commissionAmount &&
                                                commission?.commissionType
                                              ) {
                                                if (
                                                  commission?.commissionType ===
                                                  "percentage"
                                                ) {
                                                  finalAddonPrice -=
                                                    (Number(finalAddonPrice) *
                                                      Number(
                                                        commission?.commissionAmount
                                                      )) /
                                                    100;
                                                } else if (
                                                  commission?.commissionType ===
                                                  "fixed"
                                                ) {
                                                  finalAddonPrice = Number(
                                                    commission?.commissionAmount
                                                  );
                                                }
                                              }

                                              return (
                                                <div
                                                  key={index}
                                                  className={`${
                                                    styles.addon_inner_card
                                                  } ${
                                                    selectedAddOns.some(
                                                      (addon) =>
                                                        addon.id === item.id
                                                    )
                                                      ? styles.selected
                                                      : ""
                                                  } flex justify_content_between w-100 mt-7`}
                                                >
                                                  <div
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "80%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        fontSize: "15px",
                                                        fontWeight: 500,
                                                      }}
                                                    >
                                                      <span className="font_12">
                                                        {item.detail}
                                                      </span>{" "}
                                                      {commission?.commissionAmount &&
                                                        commission?.commissionType && (
                                                          <span
                                                            className={`${
                                                              selectedAddOns.some(
                                                                (addon) =>
                                                                  addon.id ===
                                                                  item.id
                                                              )
                                                                ? styles.selected_price
                                                                : ""
                                                            }`}
                                                            style={{
                                                              fontSize: "12px",
                                                              color: "red",
                                                              textDecoration:
                                                                "line-through",
                                                            }}
                                                          >
                                                            {formatIndianCurrency(
                                                              priceWithMarkup
                                                            )}{" "}
                                                            {item.perPerson
                                                              ? `* ${guest}`
                                                              : ""}
                                                          </span>
                                                        )}
                                                      <span
                                                        className={`${
                                                          styles.addon_price
                                                        } ${
                                                          selectedAddOns.some(
                                                            (addon) =>
                                                              addon.id ===
                                                              item.id
                                                          )
                                                            ? styles.selected_price
                                                            : ""
                                                        }`}
                                                      >
                                                        {formatIndianCurrency(
                                                          finalAddonPrice
                                                        )}{" "}
                                                        {item.perPerson
                                                          ? `* ${guest}`
                                                          : ""}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div className="">
                                                    <button
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                      onClick={() =>
                                                        handleSelectedAddOns({
                                                          ...item,
                                                          finalAddonPrice,
                                                          priceWithMarkup,
                                                        })
                                                      }
                                                    >
                                                      {selectedAddOns.some(
                                                        (addon) =>
                                                          addon.id === item.id
                                                      ) ? (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          <CrossWithBorder />
                                                        </div>
                                                      ) : (
                                                        <div
                                                          style={{
                                                            background:
                                                              "#009A50",
                                                            color: "#fff",
                                                            padding: "5px 7px",
                                                          }}
                                                        >
                                                          ADD
                                                        </div>
                                                      )}
                                                    </button>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      </div>
                                    )}

                                  <div
                                    className="flex justify_content_between align_items_center"
                                    onClick={() => [
                                      togglePaymentDetails(),
                                      handleButtonClick(),
                                    ]}
                                  >
                                    <h4
                                      style={{
                                        fontSize: "16px",
                                        padding: "10px 0",
                                      }}
                                    >
                                      Price Breakup
                                    </h4>
                                    <div>
                                      <button
                                        className={`${
                                          activePayment === "priceSummary"
                                            ? ""
                                            : ""
                                        }`}
                                      >
                                        {/* <svg
                                      width="13"
                                      height="8"
                                      viewBox="0 0 13 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transition: "transform 0.3s",
                                        transform: paymentDetails
                                          ? "rotate(0deg)"
                                          : "rotate(180deg)",
                                      }}
                                    >
                                      <path
                                        d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                        stroke="#222222"
                                        strokeWidth="1.5"
                                      />
                                    </svg> */}

                                        {paymentDetails ? (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="19"
                                            viewBox="0 0 18 19"
                                            fill="none"
                                          >
                                            <mask
                                              id="mask0_6868_15102"
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="18"
                                              height="19"
                                            >
                                              <rect
                                                y="0.5"
                                                width="18"
                                                height="18"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_6868_15102)">
                                              <path
                                                d="M4.38462 14.1154H7.38462C7.58077 14.1154 7.74523 14.1818 7.878 14.3145C8.01062 14.4473 8.07692 14.6118 8.07692 14.8079C8.07692 15.0042 8.01062 15.1686 7.878 15.3011C7.74523 15.4337 7.58077 15.5 7.38462 15.5H3.83446C3.598 15.5 3.39985 15.42 3.24 15.26C3.08 15.1002 3 14.902 3 14.6655V11.1154C3 10.9192 3.06638 10.7548 3.19915 10.622C3.33192 10.4894 3.49638 10.4231 3.69254 10.4231C3.88885 10.4231 4.05323 10.4894 4.18569 10.622C4.31831 10.7548 4.38462 10.9192 4.38462 11.1154V14.1154ZM13.6154 4.88462H10.6154C10.4192 4.88462 10.2548 4.81823 10.122 4.68546C9.98938 4.55269 9.92308 4.38823 9.92308 4.19208C9.92308 3.99577 9.98938 3.83138 10.122 3.69892C10.2548 3.56631 10.4192 3.5 10.6154 3.5H14.1655C14.402 3.5 14.6002 3.58 14.76 3.74C14.92 3.89985 15 4.098 15 4.33446V7.88462C15 8.08077 14.9336 8.24523 14.8008 8.378C14.6681 8.51062 14.5036 8.57692 14.3075 8.57692C14.1112 8.57692 13.9468 8.51062 13.8143 8.378C13.6817 8.24523 13.6154 8.08077 13.6154 7.88462V4.88462Z"
                                                fill="#1C1B1F"
                                              />
                                            </g>
                                          </svg>
                                        ) : (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="19"
                                            viewBox="0 0 18 19"
                                            fill="none"
                                          >
                                            <mask
                                              id="mask0_6868_15096"
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="18"
                                              height="19"
                                            >
                                              <rect
                                                y="0.5"
                                                width="18"
                                                height="18"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_6868_15096)">
                                              <path
                                                d="M6.69231 11.8077H3.69231C3.49615 11.8077 3.33177 11.7413 3.19915 11.6085C3.06638 11.4758 3 11.3113 3 11.1152C3 10.9188 3.06638 10.7545 3.19915 10.622C3.33177 10.4894 3.49615 10.4231 3.69231 10.4231H7.24269C7.479 10.4231 7.67715 10.503 7.83715 10.6628C7.997 10.8228 8.07692 11.021 8.07692 11.2573V14.8077C8.07692 15.0038 8.01054 15.1682 7.87777 15.3008C7.745 15.4336 7.58054 15.5 7.38438 15.5C7.18808 15.5 7.02369 15.4336 6.89123 15.3008C6.75862 15.1682 6.69231 15.0038 6.69231 14.8077V11.8077ZM11.3077 7.19231H14.3077C14.5038 7.19231 14.6682 7.25869 14.8008 7.39146C14.9336 7.52423 15 7.68869 15 7.88485C15 8.08115 14.9336 8.24554 14.8008 8.378C14.6682 8.51062 14.5038 8.57692 14.3077 8.57692H10.7573C10.521 8.57692 10.3228 8.497 10.1628 8.33715C10.003 8.17715 9.92308 7.979 9.92308 7.74269V4.19231C9.92308 3.99615 9.98946 3.83177 10.1222 3.69915C10.255 3.56638 10.4195 3.5 10.6156 3.5C10.8119 3.5 10.9763 3.56638 11.1088 3.69915C11.2414 3.83177 11.3077 3.99615 11.3077 4.19231V7.19231Z"
                                                fill="#1C1B1F"
                                              />
                                            </g>
                                          </svg>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                  <div>
                                    {/* {activePayment === "priceSummary" && ( */}
                                    <>
                                      {activePayment === "priceSummary" && (
                                        <>
                                          <div className="flex justify_content_between mt-7">
                                            <p>
                                              Adult Cost{" "}
                                              <small>
                                                {" "}
                                                (
                                                {calculationsOfPackages?.onlyAdultCost /
                                                  calculationsOfPackages?.adultNumber}{" "}
                                                X{" "}
                                                {
                                                  calculationsOfPackages?.adultNumber
                                                }
                                                )
                                              </small>
                                            </p>
                                            <span
                                              className={`room_text-right ${
                                                Number(
                                                  calculationsOfPackages?.onlyAdultCost
                                                ) <= 0 && "filterBlur3"
                                              }`}
                                            >
                                              {priceLoader ? (
                                                <Skeleton
                                                  width={80}
                                                  height={10}
                                                  borderRadius={4}
                                                />
                                              ) : (
                                                <>
                                                  {formatIndianCurrency(
                                                    calculationsOfPackages?.onlyAdultCost
                                                  )}
                                                </>
                                              )}
                                            </span>
                                          </div>

                                          {calculationsOfPackages?.extraAdultNumber >
                                            0 &&
                                          calculationsOfPackages?.ExtraAdultCost ? (
                                            <div className="flex justify_content_between mt-7">
                                              <p>
                                                Extra Adult Cost{" "}
                                                <small>
                                                  {" "}
                                                  (
                                                  {calculationsOfPackages?.ExtraAdultCost /
                                                    calculationsOfPackages?.extraAdultNumber}{" "}
                                                  X{" "}
                                                  {
                                                    calculationsOfPackages?.extraAdultNumber
                                                  }
                                                  )
                                                </small>
                                              </p>
                                              <span
                                                className={`room_text-right ${
                                                  Number(
                                                    calculationsOfPackages?.totalAmount
                                                  ) <= 0 && "filterBlur3"
                                                }`}
                                              >
                                                {priceLoader ? (
                                                  <Skeleton
                                                    width={80}
                                                    height={10}
                                                    borderRadius={4}
                                                  />
                                                ) : (
                                                  <>
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.ExtraAdultCost
                                                    )}
                                                  </>
                                                )}
                                                {/* {formatIndianCurrency(Number(calculationsOfPackages?.ExtraAdultCost) + Number(calculationsOfPackages?.basePrice))} */}
                                              </span>
                                            </div>
                                          ) : null}

                                          {under6AgeChildren?.length > 0 &&
                                          calculationsOfPackages?.childNumber >
                                            0 &&
                                          calculationsOfPackages?.childCostWithOutBed ? (
                                            <div className="flex justify_content_between mt-7">
                                              <p>
                                                Child Cost ({`< 6 yrs`}){" "}
                                                {/* <small>
                                                        ̀ (
                                                        {calculationsOfPackages?.childCostWithOutBed /
                                                          under6AgeChildren.length}{" "}
                                                        X {under6AgeChildren.length})
                                                      </small> */}
                                                <small>
                                                  {" "}
                                                  {Math.round(
                                                    calculationsOfPackages?.childCostWithOutBed /
                                                      under6AgeChildren.length
                                                  )}
                                                  X {under6AgeChildren.length})
                                                </small>
                                              </p>
                                              <span
                                                className={`room_text-right ${
                                                  Number(
                                                    calculationsOfPackages?.childCostWithOutBed
                                                  ) <= 0 && "filterBlur3"
                                                }`}
                                              >
                                                {priceLoader ? (
                                                  <Skeleton
                                                    width={80}
                                                    height={10}
                                                    borderRadius={4}
                                                  />
                                                ) : (
                                                  <>
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.childCostWithOutBed
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                          ) : null}

                                          {over6AgeChildren?.length > 0 &&
                                          calculationsOfPackages?.childNumber >
                                            0 &&
                                          calculationsOfPackages?.childCostWithBed ? (
                                            <div className="flex justify_content_between mt-7">
                                              <p>
                                                Child Cost ({`>= 6 yrs`}){" "}
                                                <small>
                                                  ̀ (
                                                  {calculationsOfPackages?.childCostWithBed /
                                                    over6AgeChildren.length}{" "}
                                                  X {over6AgeChildren.length})
                                                </small>
                                              </p>
                                              <span
                                                className={`room_text-right ${
                                                  Number(
                                                    calculationsOfPackages?.childCostWithBed
                                                  ) <= 0 && "filterBlur3"
                                                }`}
                                              >
                                                {priceLoader ? (
                                                  <Skeleton
                                                    width={80}
                                                    height={10}
                                                    borderRadius={4}
                                                  />
                                                ) : (
                                                  <>
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.childCostWithBed
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                          ) : null}
                                        </>
                                      )}

                                      <div className="flex justify_content_between mt-7">
                                        <h6>Total Package Cost</h6>
                                        <span
                                          className={`room_text-right alert_text ${
                                            Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          <b>
                                            {" "}
                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.basePrice
                                                )}
                                              </>
                                            )}
                                          </b>
                                        </span>
                                      </div>

                                      {activePayment === "priceSummary" && (
                                        <>
                                          {(selectedAutomaticDiscount?.length >
                                            0 ||
                                            selectedDiscount?.length > 0) && (
                                            <div
                                              className="mt-7 pt_10"
                                              style={{
                                                borderTop: "0.5px solid #ccc",
                                              }}
                                            >
                                              <p>
                                                <b>
                                                  Package Discount
                                                  {selectedAutomaticDiscount?.length >
                                                  1
                                                    ? "s"
                                                    : ""}
                                                </b>
                                              </p>
                                              {selectedAutomaticDiscount?.map(
                                                (discount, index) => (
                                                  <div
                                                    className="flex justify_content_between mt-2"
                                                    key={discount.id}
                                                  >
                                                    <span className="discount-name">
                                                      {discount.promotionName}
                                                    </span>
                                                    <span className="room_text-right green">
                                                      {discount.promotionMode ===
                                                      "percentage"
                                                        ? `${+discount.promotionAmount}%`
                                                        : `${formatIndianCurrency(
                                                            discount.promotionAmount
                                                          )}`}
                                                    </span>
                                                  </div>
                                                )
                                              )}

                                              {selectedDiscount &&
                                                selectedDiscount?.length > 0 &&
                                                selectedDiscount?.map(
                                                  (discount, index) => (
                                                    <div
                                                      className="flex justify_content_between mt-2"
                                                      key={discount.id}
                                                    >
                                                      <span className="discount-name">
                                                        {discount.promotionName}
                                                      </span>
                                                      <span className="room_text-right green">
                                                        {discount.promotionMode ===
                                                        "percentage"
                                                          ? `${+discount.promotionAmount}%`
                                                          : `${formatIndianCurrency(
                                                              discount.promotionAmount
                                                            )}`}
                                                      </span>
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                          )}

                                          {calculationsOfPackages?.discount >
                                            0 && (
                                            <div
                                              className="flex justify_content_between mt-7 border-bottom-one "
                                              style={{ paddingBottom: "7px" }}
                                            >
                                              <p>Package Cost (After Disc.)</p>
                                              <span
                                                className={`room_text-right ${
                                                  Number(
                                                    calculationsOfPackages?.totalAmount
                                                  ) <= 0 && "filterBlur3"
                                                }`}
                                              >
                                                {priceLoader ? (
                                                  <Skeleton
                                                    width={80}
                                                    height={10}
                                                    borderRadius={4}
                                                  />
                                                ) : (
                                                  <>
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.priceAfterDiscount
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                          )}

                                          {commission &&
                                            Object.keys(commission)?.length >
                                              0 && (
                                              <>
                                                <div className="flex justify_content_between mt-7">
                                                  <p>
                                                    Commission{" "}
                                                    <small>
                                                      ({" "}
                                                      {commission.commissionType ===
                                                      "fixed" ? (
                                                        <span className="room_text-right">
                                                          {formatIndianCurrency(
                                                            commission?.commissionAmount
                                                          )}
                                                        </span>
                                                      ) : (
                                                        <span className="room_text-right">
                                                          {
                                                            commission?.commissionAmount
                                                          }
                                                          %
                                                        </span>
                                                      )}
                                                      )
                                                    </small>
                                                  </p>

                                                  {formatIndianCurrency(
                                                    calculationsOfPackages?.calculatedCommissionAmount
                                                  )}
                                                </div>
                                              </>
                                            )}

                                          {selectedAddOns &&
                                            selectedAddOns?.length > 0 && (
                                              <div className="flex justify_content_between mt-7">
                                                <p>Addons Price</p>
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "end",
                                                  }}
                                                >
                                                  {commission &&
                                                    Object.keys(commission)
                                                      ?.length > 0 && (
                                                      <small
                                                        style={{
                                                          color: "red",
                                                          textDecoration:
                                                            "line-through",
                                                        }}
                                                      >
                                                        {formatIndianCurrency(
                                                          totalAddonsCostWithoutCommission
                                                        )}
                                                      </small>
                                                    )}
                                                  <b>
                                                    {formatIndianCurrency(
                                                      totalAddonsCost
                                                    )}
                                                  </b>
                                                </span>
                                              </div>
                                            )}

                                          <div className="flex justify_content_between mt-7">
                                            <p>Subtotal </p>

                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.subtotal
                                                )}
                                              </>
                                            )}
                                          </div>
                                        </>
                                      )}

                                      <div
                                        className="flex justify_content_between mt-7 border-bottom-one "
                                        style={{ paddingBottom: "7px" }}
                                      >
                                        <p>GST(5%) </p>
                                        <span
                                          className={`room_text-right  ${
                                            Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                          }`}
                                        >
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <>
                                              {formatIndianCurrency(
                                                calculationsOfPackages?.taxAmount
                                              )}
                                            </>
                                          )}
                                        </span>
                                      </div>

                                      {/* {commission && Object.keys(commission).length > 0 && calculationsOfPackages?.calculatedCommissionAmount && (
                                              <>
                                                <div className="flex justify_content_between mt-7">
                                                  <p>
                                                    Your Savings
                                                  </p>
                                                  <span className="room_text-right">
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.calculatedCommissionAmount
                                                    )}
                                                  </span>
                                                </div>
                                              </>
                                            )} */}
                                      <div
                                        className="flex justify_content_between mt-7 border-bottom-one "
                                        style={{ paddingBottom: "7px" }}
                                      >
                                        <p>Vehicle</p>
                                        <span className="room_text-right">
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <span
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {ratesOfPackages?.VehicleType?.replace(
                                                /-/g,
                                                " "
                                              )}
                                            </span>
                                          )}
                                        </span>
                                      </div>
                                      <div className="flex justify_content_between mt-7 pt_10">
                                        <h6>Total Amount to be paid</h6>
                                        <h6>
                                          <span
                                            className={` ${
                                              Number(
                                                calculationsOfPackages?.totalAmount
                                              ) <= 0 && "filterBlur3"
                                            }`}
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "end",
                                            }}
                                          >
                                            {/* {commission && Object.keys(commission).length > 0 && calculationsOfPackages?.calculatedCommissionAmount && (
                                                    <small style={{ color: 'red', textDecoration: 'line-through' }}>
                                                      {formatIndianCurrency(
                                                        Number(calculationsOfPackages?.calculatedCommissionAmount) + Number(calculationsOfPackages?.totalAmount)
                                                      )}
                                                    </small>
                                                  )} */}
                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <b>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.totalAmount
                                                )}
                                              </b>
                                            )}
                                          </span>
                                        </h6>
                                      </div>
                                      {/* <div className="flex justify_content_between mt-7">
                        <h6>
                          <b>
                            Per Pax Cost{" "}
                            <small>({calculationsOfPackages?.perPaxCount})</small>
                          </b>
                        </h6>
                        <h6>
                          <b>
                            {" "}
                            {formatIndianCurrency(
                              calculationsOfPackages?.perPaxCost
                            )}
                          </b>
                        </h6>
                      </div>{" "} */}
                                    </>
                                    {/* )} */}
                                  </div>

                                  <div className="buttons flex_direction_col">
                                    {/* <Link to={"/checkout-package"}> */}
                                    {Number(
                                      calculationsOfPackages?.totalAmount
                                    ) > 0 ? (
                                      <></>
                                    ) : (
                                      <>
                                        {singlePackage?.canCustomise && (
                                          <button
                                            onClick={navigateToCustomizePackage}
                                            className="common_btn_disabled"
                                          >
                                            Customize
                                          </button>
                                        )}
                                      </>
                                    )}
                                    {/* </Link> */}
                                    <div>
                                      {" "}
                                      <button
                                        // style={{
                                        //   background: "white",
                                        //   color: "#016937",
                                        // }}
                                        onClick={navigateToCheckOutPackage}
                                        className={styles.book_now_mobile}
                                      >
                                        <b> Book Now</b>
                                      </button>
                                    </div>
                                    <button
                                      onClick={(e) => [
                                        setPriceBreakupPopup(false),
                                        handleshowRatePopup(e),
                                      ]}
                                      className={styles.get_quote_btn}
                                    >
                                      Get Quote
                                    </button>
                                  </div>

                                  {promotions.length > 0 && (
                                    <>
                                      {promotions.some(
                                        (item) =>
                                          item.promotionType === "coupon" &&
                                          (() => {
                                            const isValidDate = checkDates(
                                              item.startDate,
                                              item.endDate
                                            );
                                            const isBookingWithinDiscount =
                                              checkBookingDates(
                                                startDate,
                                                startDate,
                                                item.startDate,
                                                item.endDate
                                              );
                                            const isUserEligible =
                                              isPromotionApplicable(
                                                userType === "customer"
                                                  ? "customers"
                                                  : userType === "agent"
                                                  ? "agents"
                                                  : "",
                                                userDetails?.id,
                                                item.promotionApplicable
                                              );
                                            const blackoutDates =
                                              item.promotionBlackOutDate || [];
                                            const isBlackout = isBlackoutDate(
                                              blackoutDates,
                                              startDate
                                            );
                                            const isApplicableForEntity =
                                              isPromotionApplicableForEntity(
                                                item.promotionEntity,
                                                "package",
                                                singlePackage?.packageId
                                              );
                                            const isConditionsValid =
                                              evaluateConditions(
                                                item.promotionConditions,
                                                startDate
                                              );

                                            return (
                                              isValidDate &&
                                              isBookingWithinDiscount &&
                                              isUserEligible &&
                                              !isBlackout &&
                                              isApplicableForEntity &&
                                              isConditionsValid
                                            );
                                          })()
                                      ) && (
                                        <div
                                          className="common_background"
                                          style={{ marginTop: "10px" }}
                                        >
                                          <div className="flex justify_content_between cursor_pointer">
                                            <div className="flex justify_content_between w-100">
                                              <div>
                                                <h5 className="text-left">
                                                  Discounts
                                                </h5>
                                              </div>
                                              {selectedDiscount && (
                                                <button
                                                  className="view_btn"
                                                  onClick={() =>
                                                    setSelectedDiscount(null)
                                                  }
                                                >
                                                  clear
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            {promotions
                                              .filter(
                                                (item) =>
                                                  item.promotionType ===
                                                  "coupon"
                                              )
                                              .map((item, index) => {
                                                const isValidDate = checkDates(
                                                  item.startDate,
                                                  item.endDate
                                                );
                                                const isBookingWithinDiscount =
                                                  checkBookingDates(
                                                    startDate,
                                                    startDate,
                                                    item.startDate,
                                                    item.endDate
                                                  );
                                                const isUserEligible =
                                                  isPromotionApplicable(
                                                    userType === "customer"
                                                      ? "customers"
                                                      : userType === "agent"
                                                      ? "agents"
                                                      : "",
                                                    userDetails?.id,
                                                    item.promotionApplicable
                                                  );
                                                const blackoutDates =
                                                  item.promotionBlackOutDate ||
                                                  [];
                                                const isBlackout =
                                                  isBlackoutDate(
                                                    blackoutDates,
                                                    startDate
                                                  );
                                                const isApplicableForEntity =
                                                  isPromotionApplicableForEntity(
                                                    item.promotionEntity,
                                                    "package",
                                                    singlePackage?.packageId
                                                  );
                                                const isConditionsValid =
                                                  evaluateConditions(
                                                    item.promotionConditions,
                                                    startDate
                                                  );

                                                return (
                                                  isValidDate &&
                                                  isBookingWithinDiscount &&
                                                  isUserEligible &&
                                                  !isBlackout &&
                                                  isApplicableForEntity &&
                                                  isConditionsValid && (
                                                    <div
                                                      key={index}
                                                      className="flex discountSingleDiv justify_content_between w-100"
                                                    >
                                                      <div className="flex">
                                                        <label
                                                          style={{
                                                            textTransform:
                                                              "capitalize",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                          htmlFor={
                                                            item?.promotionName
                                                          }
                                                        >
                                                          <input
                                                            checked={
                                                              selectedDiscount?.id ===
                                                              item?.id
                                                            }
                                                            onChange={() =>
                                                              handleDiscountChange(
                                                                item
                                                              )
                                                            }
                                                            type="radio"
                                                            id={
                                                              item?.promotionName
                                                            }
                                                          />
                                                          <div>
                                                            <div>
                                                              {item?.promotionName?.replace(
                                                                /-/g,
                                                                " "
                                                              )}
                                                            </div>
                                                          </div>
                                                        </label>
                                                      </div>
                                                      <div>
                                                        {item?.promotionMode ===
                                                        "fixed" ? (
                                                          formatIndianCurrency(
                                                            item?.promotionAmount
                                                          )
                                                        ) : (
                                                          <>
                                                            {
                                                              item?.promotionAmount
                                                            }
                                                            %
                                                          </>
                                                        )}
                                                      </div>
                                                    </div>
                                                  )
                                                );
                                              })}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* <aside>
                        <OurQuery />
                        <ChooseUs className="mt-20" />
                        <SendItinerary singlePackage={singlePackage} />
                      </aside> */}
                          </>
                        )}

                        {showRatePopup && (
                          <PackageQueryForm
                            package_id={singlePackage?.packageId}
                            setshowRatePopup={setshowRatePopup}
                            typeDetail="package"
                            packageData={singlePackage}
                            guest={guest}
                            selectedCategory={selectedCategory}
                            children={children}
                            childAge={childAge}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <section className={styles.sm_footer}>{/* <NewFooterUI /> */}</section>
    </>
  );
};

export default NewSinglePackageSearchPage;
